import React, { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import { ventasAPI, cajaAPI, productosAPI, clientesAPI, facturacionAPI, pagosAPI, cuentasPorCobrarAPI, getImageUrl } from '../services/api';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';

const Ventas = () => {
  const { formatCurrency, formatNumber } = useApp();
  const { modoEspectador } = useAuth();

  // Estado principal
  const [cajaActiva, setCajaActiva] = useState(null);
  const [loadingCaja, setLoadingCaja] = useState(true);

  // Carrito
  // FIX: Robust localStorage parsing with try/catch and Array validation
  const [carrito, setCarrito] = useState(() => {
    let savedCart = [];
    try {
      const raw = localStorage.getItem('oftalmetryc_carrito');
      if (raw) {
        const parsed = JSON.parse(raw);
        savedCart = Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) {
      console.warn('Error parsing saved cart:', e.message);
      localStorage.removeItem('oftalmetryc_carrito');
    }
    return savedCart;
  });
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  // Busqueda
  const [buscarProducto, setBuscarProducto] = useState('');
  const [productosResultados, setProductosResultados] = useState([]);
  const [buscandoProducto, setBuscandoProducto] = useState(false);
  const [buscarCliente, setBuscarCliente] = useState('');
  const [clienteResultados, setClienteResultados] = useState([]);

  // Pago
  const [showPagoModal, setShowPagoModal] = useState(false);
  const [metodoPago, setMetodoPago] = useState('efectivo');
  const [montoRecibido, setMontoRecibido] = useState('');
  const [descuentoGlobal, setDescuentoGlobal] = useState(0);
  const [esCredito, setEsCredito] = useState(false);
  const [fechaVencimientoCredito, setFechaVencimientoCredito] = useState('');
  const [abonoInicial, setAbonoInicial] = useState('');
  const [abonoInicialMetodo, setAbonoInicialMetodo] = useState('efectivo');
  const [abonoInicialMedianet, setAbonoInicialMedianet] = useState({
    codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito'
  });
  const [procesando, setProcesando] = useState(false);

  // Pagos mixtos
  const [pagosMixtos, setPagosMixtos] = useState([]);
  const [pagoMixtoActivo, setPagoMixtoActivo] = useState(false);

  // Medianet (campos para registro manual desde terminal NEW6260)
  const [medianetData, setMedianetData] = useState({
    codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito'
  });

  // Payphone config
  const [payphoneEnabled, setPayphoneEnabled] = useState(false);
  const [payphoneLoading, setPayphoneLoading] = useState(false);

  // Medianet config
  const [medianetEnabled, setMedianetEnabled] = useState(false);
  const [medianetConfig, setMedianetConfig] = useState({ terminal_id: '', codigo_comercio: '', nombre_comercio: '' });

  // [MIG-041] Entrega pendiente: cuando producto sin stock, registrar venta
  // con factura SRI inmediata pero sin descontar stock hasta llegar mercaderia.
  const [entregaPendiente, setEntregaPendiente] = useState(false);
  const [numeroOrden, setNumeroOrden] = useState(''); // [N° orden física] código manual de la orden de papel
  // [Elección SRI] null = sin elegir (obligatorio elegir CON SRI o SIN SRI para cliente con datos).
  // Consumidor Final siempre es SIN SRI (comprobante interno).
  const [facturarSRI, setFacturarSRI] = useState(null);
  const [fechaLimiteEntrega, setFechaLimiteEntrega] = useState('');
  // showModalEntregaPendiente: null o {producto} cuando se intenta agregar item sin stock.
  const [showModalEntregaPendiente, setShowModalEntregaPendiente] = useState(null);

  // Historial
  const [showHistorial, setShowHistorial] = useState(false);
  const [ventas, setVentas] = useState([]);
  const [showDetalle, setShowDetalle] = useState(null);
  // [MIG-041] Filtro del listado: 'todas' | 'entregadas' | 'pendientes'.
  const [filtroEntrega, setFiltroEntrega] = useState('todas');

  // Caja
  const [showAbrirCaja, setShowAbrirCaja] = useState(false);
  const [showCerrarCaja, setShowCerrarCaja] = useState(false);
  const [montoApertura, setMontoApertura] = useState('');
  const [montoCierre, setMontoCierre] = useState('');

  // Ticket
  const [showTicket, setShowTicket] = useState(null);

  // Nuevo cliente rapido
  const [showNuevoCliente, setShowNuevoCliente] = useState(false);
  const [nuevoCliente, setNuevoCliente] = useState({
    tipo_persona: 'natural', tipo_identificacion: 'cedula', identificacion: '',
    nombres: '', apellidos: '', razon_social: '', email: '', direccion: '', celular: ''
  });
  const [creandoCliente, setCreandoCliente] = useState(false);
  const [ciValidacion, setCiValidacion] = useState({ valido: null, existe: false });

  // Abonos
  const [showAbonoModal, setShowAbonoModal] = useState(false);
  const [abonosHistorial, setAbonosHistorial] = useState([]);
  const [loadingAbonos, setLoadingAbonos] = useState(false);
  const [abonoForm, setAbonoForm] = useState({
    monto: '', metodo_pago: 'efectivo', referencia: '', notas: '',
    motivo: '', item_especifico_id: '',
    codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito',
    facturar_sri: null
  });
  const [procesandoAbono, setProcesandoAbono] = useState(false);

  const busquedaRef = useRef(null);

  // ─── CARGAR CAJA + PAYPHONE CONFIG ───
  useEffect(() => {
    cargarCaja();
    cargarPayphoneConfig();
    cargarMedianetConfig();
  }, []);

  // ─── ATAJOS DE TECLADO ───
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (showTicket) { setShowTicket(null); e.preventDefault(); return; }
        if (showPagoModal) { setShowPagoModal(false); e.preventDefault(); return; }
        if (showHistorial) { setShowHistorial(false); e.preventDefault(); return; }
        if (showDetalle) { setShowDetalle(null); e.preventDefault(); return; }
        if (showAbrirCaja) { setShowAbrirCaja(false); e.preventDefault(); return; }
        if (showCerrarCaja) { setShowCerrarCaja(false); e.preventDefault(); return; }
        return;
      }
      if (e.key === 'F2') { e.preventDefault(); busquedaRef.current?.focus(); return; }
      if (e.key === 'F5') {
        e.preventDefault();
        if (carrito.length > 0 && cajaActiva) {
          abrirModalPago();
        }
        return;
      }
      if (e.key === 'F8') { e.preventDefault(); cargarHistorial(); setShowHistorial(true); return; }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  // eslint-disable-next-line
  }, [showPagoModal, showHistorial, showDetalle, showAbrirCaja, showCerrarCaja, showTicket, carrito, cajaActiva]);

  // ─── PERSISTIR CARRITO EN LOCALSTORAGE ───
  useEffect(() => {
    try {
      if (carrito.length > 0) {
        localStorage.setItem('oftalmetryc_carrito', JSON.stringify(carrito));
      } else {
        localStorage.removeItem('oftalmetryc_carrito');
      }
    } catch (e) {
      // FIX: Log localStorage quota errors for debugging
      console.warn('Error saving cart to localStorage:', e.message);
    }
  }, [carrito]);

  const cargarCaja = async () => {
    setLoadingCaja(true);
    try {
      const res = await cajaAPI.getActiva();
      if (res.data.success) setCajaActiva(res.data.data);
    } catch { /* silencioso */ }
    setLoadingCaja(false);
  };

  const cargarPayphoneConfig = async () => {
    try {
      const res = await pagosAPI.payphoneConfig();
      if (res.data.success) {
        setPayphoneEnabled(res.data.data.enabled && res.data.data.configured);
      }
    } catch { /* silencioso - payphone no disponible */ }
  };

  const cargarMedianetConfig = async () => {
    try {
      const res = await pagosAPI.medianetConfig();
      if (res.data.success) {
        setMedianetEnabled(res.data.data.enabled);
        setMedianetConfig({
          terminal_id: res.data.data.terminal_id || '',
          codigo_comercio: res.data.data.codigo_comercio || '',
          nombre_comercio: res.data.data.nombre_comercio || ''
        });
      }
    } catch { /* silencioso */ }
  };

  // ─── BUSCAR PRODUCTOS ───
  const buscarProductos = useCallback(async (texto) => {
    if (!texto || texto.length < 2) { setProductosResultados([]); return; }
    setBuscandoProducto(true);
    try {
      const res = await productosAPI.getAll({ buscar: texto, limit: 10 });
      if (res.data.success) setProductosResultados(res.data.data || []);
    } catch { /* silencioso */ }
    setBuscandoProducto(false);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => buscarProductos(buscarProducto), 300);
    return () => clearTimeout(t);
  }, [buscarProducto, buscarProductos]);

  const handleBusquedaKeyDown = (e) => {
    if (e.key === 'Enter' && productosResultados.length > 0) {
      e.preventDefault();
      agregarAlCarrito(productosResultados[0]);
    }
  };

  // ─── BUSCAR CLIENTES ───
  const buscarClientes = useCallback(async (texto) => {
    if (!texto || texto.length < 2) { setClienteResultados([]); return; }
    try {
      const res = await clientesAPI.getAll({ buscar: texto, limit: 8 });
      if (res.data.success) setClienteResultados(res.data.data || []);
    } catch { /* silencioso */ }
  }, []);

  useEffect(() => {
    const t = setTimeout(() => buscarClientes(buscarCliente), 400);
    return () => clearTimeout(t);
  }, [buscarCliente, buscarClientes]);

  // ─── AGREGAR AL CARRITO ───
  // [MIG-041] Si producto sin stock y la cajera no ha activado entrega pendiente,
  // abrir modal preguntando si quiere registrar como ENTREGA PENDIENTE
  // (factura inmediata, descuento de stock cuando llegue mercaderia).
  const agregarAlCarrito = (producto) => {
    // FIX: Null checks for product data access
    if (!producto || !producto.id) { toast.error('Producto no válido'); return; }
    const stockDisponible = parseInt(producto.stock_actual) || 0;
    const existente = carrito.find(i => i.producto_id === producto.id);
    // [Venta sin stock] No se bloquea la venta por falta de stock: se factura
    // igual y el faltante se descuenta automaticamente al reponer inventario.
    // Solo mostramos un aviso informativo cuando la cantidad supera el stock.
    const cantidadTrasAgregar = (existente ? existente.cantidad : 0) + 1;
    if (cantidadTrasAgregar > stockDisponible) {
      toast.info('Sin stock suficiente: se facturará y se descontará automáticamente al reponer inventario.', { autoClose: 4000 });
    }
    if (existente) {
      setCarrito(carrito.map(i => i.producto_id === producto.id ? { ...i, cantidad: i.cantidad + 1 } : i));
    } else {
      // FIX: Safe parseFloat with fallback for price and IVA
      const precioVenta = parseFloat(producto.precio_venta) || 0;
      const ivaPorcentaje = parseFloat(producto.iva_porcentaje) || 15;
      setCarrito([...carrito, {
        producto_id: producto.id,
        nombre: producto.nombre || 'Sin nombre',
        codigo: producto.codigo || '',
        precio_unitario: precioVenta,
        cantidad: 1,
        descuento_porcentaje: 0,
        stock: stockDisponible,
        iva_porcentaje: ivaPorcentaje
      }]);
    }
    setBuscarProducto('');
    setProductosResultados([]);
    busquedaRef.current?.focus();
  };

  // [MIG-041] Confirmar desde modal: activar modo entrega pendiente y agregar el producto.
  const activarEntregaPendienteYAgregar = (producto) => {
    setEntregaPendiente(true);
    setShowModalEntregaPendiente(null);
    // Agregar el item directamente (saltar verificacion de stock).
    const precioVenta = parseFloat(producto.precio_venta) || 0;
    const ivaPorcentaje = parseFloat(producto.iva_porcentaje) || 15;
    const existente = carrito.find(i => i.producto_id === producto.id);
    if (existente) {
      setCarrito(carrito.map(i => i.producto_id === producto.id ? { ...i, cantidad: i.cantidad + 1 } : i));
    } else {
      setCarrito([...carrito, {
        producto_id: producto.id,
        nombre: producto.nombre || 'Sin nombre',
        codigo: producto.codigo || '',
        precio_unitario: precioVenta,
        cantidad: 1,
        descuento_porcentaje: 0,
        stock: parseInt(producto.stock_actual) || 0,
        iva_porcentaje: ivaPorcentaje
      }]);
    }
    setBuscarProducto('');
    setProductosResultados([]);
  };

  // FIX: Validate campo values to prevent NaN or out-of-range values
  const actualizarItem = (idx, campo, valor) => {
    setCarrito(carrito.map((item, i) => {
      if (i !== idx) return item;
      if (campo === 'cantidad') {
        // [Venta sin stock] No limitar por stock; el faltante se descuenta al reponer inventario.
        return { ...item, [campo]: Math.max(1, parseInt(valor) || 1) };
      }
      if (campo === 'descuento_porcentaje') {
        // FIX: Clamp discount 0-100 to prevent negative subtotals
        return { ...item, [campo]: Math.max(0, Math.min(100, parseFloat(valor) || 0)) };
      }
      if (campo === 'precio_unitario') {
        // FIX: Prevent negative prices
        return { ...item, [campo]: Math.max(0, parseFloat(valor) || 0) };
      }
      return { ...item, [campo]: parseFloat(valor) || 0 };
    }));
  };

  const eliminarItem = (idx) => setCarrito(carrito.filter((_, i) => i !== idx));

  // ─── CALCULOS ───
  const calcularTotales = () => {
    let subtotal0 = 0, subtotalIva = 0, descuentoItems = 0;
    const subtotalPorTasa = {};
    carrito.forEach(item => {
      // FIX: Null checks for price and quantity with safe defaults
      const precio = parseFloat(item.precio_unitario) || 0;
      const cantidad = parseInt(item.cantidad) || 0;
      const descPct = parseFloat(item.descuento_porcentaje) || 0;
      const subtItem = precio * cantidad;
      // FIX: Clamp item discount to prevent negative line totals
      const desc = (subtItem * Math.min(100, Math.max(0, descPct))) / 100;
      const neto = Math.max(0, subtItem - desc);
      const ivaPct = parseFloat(item.iva_porcentaje) || 0;
      descuentoItems += desc;
      if (ivaPct > 0) {
        subtotalIva += neto;
        subtotalPorTasa[ivaPct] = (subtotalPorTasa[ivaPct] || 0) + neto;
      } else { subtotal0 += neto; }
    });
    // FIX: Calcular IVA sobre subtotal agrupado por tasa, no por item individual
    // Esto evita acumulación de errores de redondeo (ej: $64.99 en vez de $65.00)
    const ivaTotal = Object.entries(subtotalPorTasa).reduce((sum, [tasa, sub]) =>
      sum + parseFloat((sub * parseFloat(tasa) / 100).toFixed(2)), 0
    );
    const subtotal = subtotal0 + subtotalIva;
    // FIX: Clamp global discount so total never goes negative
    const descGlobal = Math.max(0, parseFloat(descuentoGlobal) || 0);
    const total = Math.max(0, subtotal + ivaTotal - descGlobal);
    const cambio = metodoPago === 'efectivo' && !pagoMixtoActivo
      ? Math.max(0, (parseFloat(montoRecibido) || 0) - total)
      : 0;
    return { subtotal0, subtotalIva, subtotal, iva: ivaTotal, descuentoItems, descGlobal, total, cambio };
  };

  const totales = calcularTotales();

  // ─── ABRIR MODAL DE PAGO ───
  const abrirModalPago = () => {
    setShowPagoModal(true);
    setMontoRecibido((parseFloat(totales.total) || 0).toFixed(2));
    setMetodoPago('efectivo');
    setEsCredito(false);
    setFechaVencimientoCredito('');
    setPagoMixtoActivo(false);
    setPagosMixtos([]);
    setMedianetData({ codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito' });
  };

  // ─── PAGOS MIXTOS ───
  const totalPagosMixtos = pagosMixtos.reduce((sum, p) => sum + (parseFloat(p.monto) || 0), 0);
  const restanteMixto = Math.max(0, totales.total - totalPagosMixtos);

  const agregarPagoMixto = (metodo) => {
    if (restanteMixto <= 0) { toast.warning('Ya se cubrio el monto total'); return; }
    setPagosMixtos([...pagosMixtos, {
      metodo,
      monto: (parseFloat(restanteMixto) || 0).toFixed(2),
      codigo_autorizacion: '',
      ultimos_digitos: '',
      marca_tarjeta: metodo.includes('tarjeta') ? 'Visa' : '',
      tipo_tarjeta: 'credito'
    }]);
  };

  const actualizarPagoMixto = (idx, campo, valor) => {
    setPagosMixtos(pagosMixtos.map((p, i) => i === idx ? { ...p, [campo]: valor } : p));
  };

  const eliminarPagoMixto = (idx) => {
    setPagosMixtos(pagosMixtos.filter((_, i) => i !== idx));
  };

  // ─── PROCESAR VENTA ───
  const procesarVenta = async () => {
    if (procesando) return;
    if (carrito.length === 0) { toast.error('Agregue productos'); return; }

    // FIX: Validate total is positive before proceeding with any payment flow
    if (totales.total <= 0) {
      // Si el total es 0 por productos sin precio, decir CUAL (no dejar adivinar al cajero)
      const sinPrecio = carrito.filter(i => (parseFloat(i.precio_unitario) || 0) <= 0);
      if (sinPrecio.length > 0) {
        toast.error(`Sin precio: ${sinPrecio.map(i => i.nombre).join(', ')}. Escribe el precio en el carrito antes de cobrar.`);
      } else {
        toast.error('El total de la venta debe ser mayor a cero');
      }
      return;
    }

    // Validar descuento global no exceda subtotal
    const descGlobal = parseFloat(descuentoGlobal) || 0;
    const subtotalFinal = totales.subtotal + totales.iva;
    if (descGlobal > subtotalFinal) {
      toast.error('El descuento no puede ser mayor al subtotal');
      return;
    }

    // Validar cliente obligatorio para crédito
    if (esCredito && !clienteSeleccionado) {
      toast.error('Debe seleccionar un cliente para ventas a crédito'); return;
    }

    // [Elección obligatoria] Cliente: Consumidor Final o con datos (sin default).
    if (!clienteSeleccionado) {
      toast.error('Elija el cliente: Consumidor Final o un cliente con datos.');
      return;
    }
    const esConsumidorFinal = clienteSeleccionado.identificacion === '9999999999999';

    // [Elección obligatoria] Facturación: CON SRI o SIN SRI (sin default; CF siempre SIN SRI).
    if (!esConsumidorFinal && facturarSRI === null) {
      toast.error('Elija si la venta se factura CON SRI o SIN SRI (comprobante interno).');
      return;
    }

    // CRITICO: Normativa SRI 2026 (Res. NAC-DGERCGC25-00000017):
    // - Monto máximo como Consumidor Final: $50.00
    if (esConsumidorFinal && totales.total >= 50) {
      toast.error('⚠️ Ventas de $50 o más requieren datos del cliente (normativa SRI 2026). Seleccione o cree un cliente antes de cobrar.');
      return;
    }

    // Validar abono inicial obligatorio para crédito
    if (esCredito) {
      const abonoIni = parseFloat(abonoInicial) || 0;
      if (abonoIni <= 0) {
        toast.error('Debe ingresar un abono inicial para ventas a crédito'); return;
      }
      if (abonoIni >= totales.total) {
        toast.error('El abono inicial no puede ser igual o mayor al total. Use otro método de pago.'); return;
      }
      if (abonoInicialMetodo === 'tarjeta_medianet' && !abonoInicialMedianet.codigo_autorizacion) {
        toast.error('Ingrese el código de autorización de Medianet para el abono inicial'); return;
      }
    }

    // Validaciones segun metodo (NO aplica para crédito ni mixto)
    if (!pagoMixtoActivo && !esCredito) {
      if (metodoPago === 'efectivo') {
        const recibido = parseFloat(montoRecibido) || 0;
        if (recibido < totales.total - 0.01) {
          toast.error(`Monto recibido insuficiente. Recibido: $${(recibido || 0).toFixed(2)}, Total: $${(parseFloat(totales.total) || 0).toFixed(2)}`); return;
        }
      }
      if (metodoPago === 'tarjeta_medianet' && !medianetData.codigo_autorizacion) {
        toast.error('Ingrese el codigo de autorizacion de Medianet'); return;
      }
    }

    if (pagoMixtoActivo) {
      if (totalPagosMixtos < totales.total - 0.01) {
        toast.error(`Faltan ${formatCurrency(restanteMixto)} por cubrir`); return;
      }
      // Validar que pagos con tarjeta tengan codigo autorizacion
      for (const p of pagosMixtos) {
        if ((p.metodo === 'tarjeta_medianet' || p.metodo === 'tarjeta') && !p.codigo_autorizacion) {
          toast.error('Ingrese codigo de autorizacion para pagos con tarjeta'); return;
        }
      }
    }

    setProcesando(true);
    try {
      // Armar array de pagos
      let pagosArray = [];
      if (pagoMixtoActivo) {
        pagosArray = pagosMixtos.map(p => ({
          metodo: p.metodo,
          monto: parseFloat(p.monto) || 0,
          codigo_autorizacion: p.codigo_autorizacion || null,
          ultimos_digitos: p.ultimos_digitos || null,
          marca_tarjeta: p.marca_tarjeta || null,
          tipo_tarjeta: p.tipo_tarjeta || null,
          terminal_id: p.metodo === 'tarjeta_medianet' ? (medianetConfig.terminal_id || null) : null,
          referencia_pago: p.metodo === 'tarjeta_medianet' && p.codigo_autorizacion ? `MN-${p.codigo_autorizacion}` : null
        }));
      } else if (!esCredito && metodoPago === 'tarjeta_medianet') {
        pagosArray = [{
          metodo: 'tarjeta_medianet',
          monto: totales.total,
          codigo_autorizacion: medianetData.codigo_autorizacion,
          ultimos_digitos: medianetData.ultimos_digitos,
          marca_tarjeta: medianetData.marca_tarjeta,
          tipo_tarjeta: medianetData.tipo_tarjeta,
          terminal_id: medianetConfig.terminal_id || null,
          referencia_pago: `MN-${medianetData.codigo_autorizacion}`
        }];
      } else if (!esCredito && metodoPago !== 'efectivo') {
        pagosArray = [{ metodo: metodoPago, monto: totales.total }];
      }

      const metodoFinal = pagoMixtoActivo ? 'mixto' : (esCredito ? 'credito' : metodoPago);

      const res = await ventasAPI.create({
        cliente_id: clienteSeleccionado?.id || null,
        items: carrito.map(i => ({
          producto_id: i.producto_id, cantidad: i.cantidad,
          precio_unitario: i.precio_unitario, descuento_porcentaje: i.descuento_porcentaje,
          descripcion_adicional: i.descripcion_adicional || null
        })),
        metodo_pago: metodoFinal,
        monto_recibido: esCredito ? 0 : (parseFloat(montoRecibido) || totales.total),
        descuento_total: parseFloat(descuentoGlobal) || 0,
        es_credito: esCredito,
        fecha_vencimiento_credito: esCredito ? (fechaVencimientoCredito || null) : null,
        abono_inicial: esCredito ? {
          monto: parseFloat(abonoInicial) || 0,
          metodo_pago: abonoInicialMetodo,
          codigo_autorizacion: abonoInicialMetodo === 'tarjeta_medianet' ? abonoInicialMedianet.codigo_autorizacion : null,
          ultimos_digitos: abonoInicialMetodo === 'tarjeta_medianet' ? abonoInicialMedianet.ultimos_digitos : null,
          marca_tarjeta: abonoInicialMetodo === 'tarjeta_medianet' ? abonoInicialMedianet.marca_tarjeta : null,
          tipo_tarjeta: abonoInicialMetodo === 'tarjeta_medianet' ? abonoInicialMedianet.tipo_tarjeta : null
        } : null,
        tipo_venta: 'directa',
        pagos: pagosArray,
        numero_orden: numeroOrden || null,
        // [Elección SRI] CF siempre SIN SRI; cliente con datos: lo elegido por el cajero.
        facturar_sri: (clienteSeleccionado?.identificacion === '9999999999999') ? false : facturarSRI === true,
        // [MIG-041] Entrega pendiente: si el modo esta activo, el backend
        // saltea la verificacion de stock y guarda la venta con
        // estado_entrega='pendiente_stock'. Cliente_id real es obligatorio.
        entrega_pendiente: entregaPendiente,
        fecha_limite_entrega: entregaPendiente ? (fechaLimiteEntrega || null) : null
      });

      if (res.data.success) {
        const ventaData = res.data.data;
        toast.success(entregaPendiente
          ? `Venta ${ventaData.codigo} registrada como ENTREGA PENDIENTE (factura emitida, stock se descontara cuando llegue mercaderia)`
          : (esCredito
            ? `Venta a crédito ${ventaData.codigo} registrada! Abono: ${formatCurrency(parseFloat(abonoInicial))} | Saldo: ${formatCurrency(totales.total - parseFloat(abonoInicial))}`
            : `Venta ${ventaData.codigo} registrada! Total: ${formatCurrency(totales.total)}${(clienteSeleccionado?.identificacion === '9999999999999' || facturarSRI === false) ? ' — SIN factura SRI (comprobante interno)' : ''}`)
        );

        // Cargar ticket automaticamente
        cargarTicket(ventaData.id);

        // Limpiar estado
        localStorage.removeItem('oftalmetryc_carrito');
        setCarrito([]); setClienteSeleccionado(null); setShowPagoModal(false);
        setMontoRecibido(''); setDescuentoGlobal(0); setEsCredito(false);
        setFechaVencimientoCredito(''); setAbonoInicial(''); setAbonoInicialMetodo('efectivo');
        setAbonoInicialMedianet({ codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito' });
        setMetodoPago('efectivo'); setPagoMixtoActivo(false); setPagosMixtos([]);
        setMedianetData({ codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito' });
        // [MIG-041] Resetear modo entrega pendiente despues de registrar.
        setEntregaPendiente(false); setFechaLimiteEntrega('');
        setNumeroOrden('');
        setFacturarSRI(null); // [Elección SRI] la siguiente venta vuelve a exigir la elección
        cargarCaja();
        busquedaRef.current?.focus();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al procesar venta');
    } finally {
      setProcesando(false);
    }
  };

  // ─── PAYPHONE ───
  const iniciarPagoPayphone = async () => {
    if (carrito.length === 0) { toast.error('Agregue productos'); return; }

    setPayphoneLoading(true);
    try {
      // Primero crear la venta como pendiente? No - Payphone necesita redirect.
      // Preparar la transaccion Payphone
      const res = await pagosAPI.payphonePrepare({
        monto: totales.total,
        subtotal_iva: totales.subtotalIva,
        subtotal_0: totales.subtotal0,
        iva: totales.iva,
        email: clienteSeleccionado?.email || '',
        celular: clienteSeleccionado?.celular || '',
        identificacion: clienteSeleccionado?.identificacion || ''
      });

      if (res.data.success) {
        const { payWithCard } = res.data.data;
        if (payWithCard) {
          // Redirigir a la pagina de pago de Payphone
          window.location.href = payWithCard;
        } else {
          toast.error('No se obtuvo URL de pago de Payphone');
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al preparar pago Payphone');
    }
    setPayphoneLoading(false);
  };

  // ─── TICKET DE VENTA ───
  const cargarTicket = async (ventaId) => {
    try {
      const res = await pagosAPI.getTicket(ventaId);
      if (res.data.success) {
        setShowTicket(res.data.data);
      }
    } catch { /* silencioso */ }
  };

  const imprimirTicket = () => {
    const printWindow = window.open('', '_blank', 'width=400,height=700');
    if (!printWindow || !showTicket) return;
    const t = showTicket;
    const logoAncho = t.negocio.logo_ancho || 120;

    // FIX: null safety — guard detalle array and toFixed on total
    const itemsHtml = (Array.isArray(t.detalle) ? t.detalle : []).map(d =>
      `<tr>
        <td class="txt">${d.nombre || ''}<br><small>${d.codigo || ''} x${d.cantidad || 0}</small></td>
        <td class="txt right">$${(parseFloat(d.total) || 0).toFixed(2)}</td>
      </tr>`
    ).join('');

    // FIX: null safety — guard pagos array and toFixed on monetary values
    const pagosHtml = t.pagos && t.pagos.length > 0
      ? t.pagos.map(p =>
        `<div class="txt-sm">${metodoLabel(p.metodo)}: $${(parseFloat(p.monto) || 0).toFixed(2)}${p.ultimos_digitos ? ' (****' + p.ultimos_digitos + ')' : ''}${p.autorizacion ? ' Auth:' + p.autorizacion : ''}</div>`
      ).join('')
      : `<div class="txt-sm">${metodoLabel(t.venta?.metodo_pago)}: $${(parseFloat(t.venta?.total) || 0).toFixed(2)}</div>`;

    // URL absoluta del logo
    const logoFullUrl = t.negocio.mostrar_logo && t.negocio.logo_url
      ? (t.negocio.logo_url.startsWith('http') ? t.negocio.logo_url : `${window.location.origin}${getImageUrl(t.negocio.logo_url)}`)
      : '';

    const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Ticket ${t.venta.codigo}</title>
<style>
  /* ═══ RESET - sin margenes fijos, adaptable a cualquier papel ═══ */
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html, body {
    width: 100%;
    margin: 0;
    padding: 0;
    font-family: 'Courier New', 'Lucida Console', monospace;
    font-size: 12px;
    line-height: 1.3;
    color: #000;
    background: #fff;
  }
  /* Contenedor principal - se adapta al ancho del papel */
  .ticket {
    width: 100%;
    max-width: 100%;
    padding: 8px;
  }
  .center { text-align: center; }
  .right { text-align: right; }
  .bold { font-weight: bold; }
  .line { border-top: 1px dashed #000; margin: 4px 0; }
  .txt { font-size: 11px; }
  .txt-sm { font-size: 10px; }
  .txt-xs { font-size: 9px; word-break: break-all; }
  .negocio-name { font-size: 14px; font-weight: bold; }
  .total-row { font-size: 14px; font-weight: bold; }

  /* Tablas fluidas */
  table { width: 100%; border-collapse: collapse; }
  td { padding: 1px 0; vertical-align: top; }

  /* Logo B&W */
  .logo-bw {
    filter: grayscale(100%) contrast(1.2);
    max-width: ${logoAncho}px;
    max-height: ${Math.round(logoAncho * 0.6)}px;
    object-fit: contain;
    display: block;
    margin: 0 auto 4px;
  }

  /* ═══ IMPRESION - sin margenes, ajusta al papel ═══ */
  @page {
    margin: 0;
    padding: 0;
  }
  @media print {
    html, body {
      width: 100%;
      margin: 0 !important;
      padding: 0 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .ticket {
      width: 100% !important;
      padding: 4px !important;
    }
    .logo-bw {
      filter: grayscale(100%) contrast(1.5) !important;
      -webkit-filter: grayscale(100%) contrast(1.5) !important;
    }
    /* Evitar cortes de pagina dentro del ticket */
    .ticket { page-break-inside: avoid; }
  }
</style></head><body>
<div class="ticket">
  ${logoFullUrl ? `<div class="center"><img src="${logoFullUrl}" class="logo-bw" /></div>` : ''}
  <div class="center negocio-name">${t.negocio.nombre}</div>
  ${t.negocio.ruc ? `<div class="center txt-sm">RUC: ${t.negocio.ruc}</div>` : ''}
  ${t.negocio.direccion ? `<div class="center txt-sm">${t.negocio.direccion}</div>` : ''}
  ${t.negocio.telefono ? `<div class="center txt-sm">Tel: ${t.negocio.telefono}</div>` : ''}
  ${t.negocio.sucursal ? `<div class="center txt-sm">Suc: ${t.negocio.sucursal}</div>` : ''}
  <div class="line"></div>
  <div class="center bold" style="font-size:12px">NOTA DE VENTA</div>
  <div class="txt bold">No: ${t.venta.codigo}</div>
  ${t.venta.numero_orden ? `<div class="txt bold">Orden fisica: ${t.venta.numero_orden}</div>` : ''}
  ${t.venta.ordenes_codigos ? `<div class="txt">Orden trab.: ${t.venta.ordenes_codigos}</div>` : ''}
  <div class="txt">Fecha: ${t.venta.fecha ? new Date(t.venta.fecha).toLocaleString('es-EC') : '—'}</div>
  <div class="txt">Vendedor: ${t.venta.vendedor || '-'}</div>
  <div class="line"></div>
  <div class="txt">Cliente: ${t.cliente.nombre}</div>
  <div class="txt">CI/RUC: ${t.cliente.identificacion}</div>
  <div class="line"></div>
  <table>${itemsHtml}</table>
  <div class="line"></div>
  <table>
    <tr><td class="txt">Subtotal 0%</td><td class="txt right">$${(parseFloat(t.venta.subtotal_0) || 0).toFixed(2)}</td></tr>
    <tr><td class="txt">Subtotal IVA</td><td class="txt right">$${(parseFloat(t.venta.subtotal_iva) || 0).toFixed(2)}</td></tr>
    ${parseFloat(t.venta.descuento) > 0 ? `<tr><td class="txt" style="color:red">Descuento</td><td class="txt right" style="color:red">-$${(parseFloat(t.venta.descuento) || 0).toFixed(2)}</td></tr>` : ''}
    <tr><td class="txt">IVA</td><td class="txt right">$${(parseFloat(t.venta.iva) || 0).toFixed(2)}</td></tr>
    <tr><td class="total-row">TOTAL</td><td class="total-row right">$${(parseFloat(t.venta.total) || 0).toFixed(2)}</td></tr>
    ${parseFloat(t.venta.monto_recibido) > 0 && t.venta.metodo_pago === 'efectivo' ? `
      <tr><td class="txt">Recibido</td><td class="txt right">$${(parseFloat(t.venta.monto_recibido) || 0).toFixed(2)}</td></tr>
      <tr><td class="txt">Cambio</td><td class="txt right">$${(parseFloat(t.venta.cambio) || 0).toFixed(2)}</td></tr>
    ` : ''}
  </table>
  <div class="line"></div>
  <div class="txt-sm bold">Forma de Pago:</div>
  ${pagosHtml}
  ${t.venta.es_credito ? `
    <div class="line"></div>
    <div class="txt bold" style="color:orange">*** VENTA A CREDITO ***</div>
    <div class="txt">Saldo: $${(parseFloat(t.venta.saldo_pendiente) || 0).toFixed(2)}</div>
  ` : ''}
  ${t.factura ? `
    <div class="line"></div>
    <div class="txt-sm bold">FACTURA ELECTRONICA</div>
    <div class="txt-xs bold">Factura: ${t.factura.numero || '-'}</div>
    <div class="txt-xs">Clave: ${t.factura.clave_acceso || '-'}</div>
    <div class="txt-xs">Auth: ${t.factura.autorizacion || '-'}</div>
  ` : ''}
  <div class="line"></div>
  <div class="center txt-sm">${t.mensaje_pie}</div>
  <div class="center txt-xs" style="margin-top:4px;color:#666">Powered by Oftalmetryc</div>
</div>
<script>
  // Esperar a que cargue el logo antes de imprimir
  var imgs = document.querySelectorAll('img');
  var loaded = 0;
  var total = imgs.length;
  if (total === 0) { window.print(); }
  else {
    imgs.forEach(function(img) {
      if (img.complete) { loaded++; if(loaded>=total) window.print(); }
      else {
        img.onload = img.onerror = function() { loaded++; if(loaded>=total) window.print(); };
      }
    });
  }
</script>
</body></html>`;

    printWindow.document.write(html);
    printWindow.document.close();
  };

  // Helper para labels de metodo de pago
  const metodoLabel = (metodo) => {
    const labels = {
      'efectivo': 'Efectivo', 'tarjeta': 'Tarjeta', 'tarjeta_medianet': 'Medianet',
      'tarjeta_payphone': 'Payphone', 'transferencia': 'Transferencia',
      'credito': 'Credito', 'mixto': 'Pago Mixto'
    };
    return labels[metodo] || metodo;
  };

  const metodoIcon = (metodo) => {
    const icons = {
      'efectivo': 'bi-cash', 'tarjeta': 'bi-credit-card', 'tarjeta_medianet': 'bi-credit-card-2-front',
      'tarjeta_payphone': 'bi-phone', 'transferencia': 'bi-bank', 'credito': 'bi-calendar3', 'mixto': 'bi-layers'
    };
    return icons[metodo] || 'bi-cash';
  };

  // ─── CAJA ───
  const abrirCaja = async () => {
    try {
      const res = await cajaAPI.abrir({ monto_apertura: parseFloat(montoApertura) || 0 });
      if (res.data.success) { toast.success('Caja abierta'); setShowAbrirCaja(false); setMontoApertura(''); cargarCaja(); }
    } catch (error) { toast.error(error.response?.data?.error || 'Error al abrir caja'); }
  };

  const cerrarCaja = async () => {
    try {
      const res = await cajaAPI.cerrar({ monto_real: parseFloat(montoCierre) || 0 });
      if (res.data.success) {
        toast.success(`Caja cerrada. Diferencia: ${formatCurrency(res.data.data.diferencia)}`);
        setShowCerrarCaja(false); setMontoCierre(''); cargarCaja();
      }
    } catch (error) { toast.error(error.response?.data?.error || 'Error al cerrar caja'); }
  };

  // ─── HISTORIAL ───
  const cargarHistorial = async () => {
    try {
      const res = await ventasAPI.getAll({ limit: 50 });
      if (res.data.success) setVentas(res.data.data);
    } catch { /* silencioso */ }
  };

  const verDetalle = async (id) => {
    try {
      const res = await ventasAPI.getById(id);
      if (res.data.success) setShowDetalle(res.data.data);
    } catch { toast.error('Error al cargar detalle'); }
  };

  // ─── ABONOS ───
  const cargarAbonosVenta = async (ventaId) => {
    setLoadingAbonos(true);
    try {
      const res = await cuentasPorCobrarAPI.getAbonos(ventaId);
      if (res.data.success) setAbonosHistorial(res.data.data);
    } catch { setAbonosHistorial([]); }
    setLoadingAbonos(false);
  };

  const abrirAbonoModal = (venta) => {
    setAbonoForm({
      monto: '', metodo_pago: 'efectivo', referencia: '', notas: '',
      motivo: '', item_especifico_id: '',
      codigo_autorizacion: '', ultimos_digitos: '', marca_tarjeta: 'Visa', tipo_tarjeta: 'credito',
      // [Elección SRI al saldar] null = sin elegir. Obligatorio cuando el abono cierra la cuenta.
      facturar_sri: null
    });
    setShowAbonoModal(true);
  };

  // ─── [Elección SRI al saldar] ───────────────────────────────────────────
  // Mismo criterio que en Cuentas por Cobrar (comparten el endpoint
  // POST /ventas/:id/abono): si el abono deja el saldo en 0 y la venta todavía
  // no está facturada, la decisión CON/SIN SRI debe ser explícita.
  const abonoSaldaCuenta = () => {
    const saldo = parseFloat(showDetalle?.saldo_pendiente) || 0;
    // Redondeado a centavos igual que el backend (`montoAbono`), si no un monto con 3
    // decimales haría que frontend y backend discrepen sobre si la cuenta queda saldada.
    const monto = parseFloat((parseFloat(abonoForm.monto) || 0).toFixed(2));
    return monto > 0 && parseFloat((saldo - monto).toFixed(2)) <= 0;
  };
  const requiereEleccionSri = () => (
    abonoSaldaCuenta() && !showDetalle?.facturada &&
    !!showDetalle?.cliente_id && Number(showDetalle.cliente_id) !== 1
  );

  const registrarAbono = async () => {
    if (!showDetalle) return;
    const monto = parseFloat(abonoForm.monto);
    if (!monto || monto <= 0) { toast.error('Ingrese un monto válido'); return; }
    if (monto > parseFloat(showDetalle.saldo_pendiente)) { toast.error('El abono excede el saldo pendiente'); return; }
    // [MIG-039] Justificativo obligatorio mín 15 chars
    if (!abonoForm.motivo || abonoForm.motivo.trim().length < 15) {
      toast.error('El motivo del abono es obligatorio (mínimo 15 caracteres)');
      return;
    }
    // [Elección SRI al saldar] El backend también lo exige (HTTP 400); esto evita el viaje.
    if (requiereEleccionSri() && abonoForm.facturar_sri === null) {
      toast.error('Este abono salda la cuenta: elija si se factura CON SRI o SIN SRI.');
      return;
    }

    setProcesandoAbono(true);
    try {
      const payload = {
        monto: abonoForm.monto,
        metodo_pago: abonoForm.metodo_pago,
        referencia: abonoForm.referencia || null,
        notas: abonoForm.notas || null,
        motivo: abonoForm.motivo.trim(),
        item_especifico_id: abonoForm.item_especifico_id || null
      };
      // [Elección SRI al saldar] Solo se envía cuando hubo decisión explícita.
      if (requiereEleccionSri()) payload.facturar_sri = abonoForm.facturar_sri;
      // Agregar campos Medianet si aplica
      if (abonoForm.metodo_pago === 'tarjeta_medianet') {
        payload.codigo_autorizacion = abonoForm.codigo_autorizacion;
        payload.ultimos_digitos = abonoForm.ultimos_digitos;
        payload.marca_tarjeta = abonoForm.marca_tarjeta;
        payload.tipo_tarjeta = abonoForm.tipo_tarjeta;
      }

      const res = await ventasAPI.registrarAbono(showDetalle.id, payload);
      if (res.data.success) {
        toast.success(`Abono de $${(monto || 0).toFixed(2)} registrado exitosamente`);
        // [Elección SRI al saldar] Confirmar al cajero qué pasó con el comprobante.
        if (res.data.data?.cuenta_saldada) {
          if (res.data.data.facturar_sri === true) {
            if (res.data.data.factura_en_proceso) toast.info('Cuenta saldada — se está generando la factura SRI.');
            else toast.warning('Cuenta saldada, pero la facturación automática está APAGADA: la factura NO se emitió. Génerela manualmente.');
          } else if (res.data.data.facturar_sri === false) {
            toast.info('Cuenta saldada SIN factura SRI — entregue el comprobante interno.');
          }
        }
        setShowAbonoModal(false);
        // Recargar detalle de venta
        const ventaRes = await ventasAPI.getById(showDetalle.id);
        if (ventaRes.data.success) setShowDetalle(ventaRes.data.data);
        cargarAbonosVenta(showDetalle.id);
        cargarHistorial();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al registrar abono');
    }
    setProcesandoAbono(false);
  };

  // ─── FACTURACION ───
  const generarFactura = async (ventaId) => {
    try {
      const res = await facturacionAPI.procesoCompleto(ventaId);
      if (res.data.success) {
        toast.success('Factura electronica generada');
      } else {
        toast.info(res.data.message || 'Factura en proceso');
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al generar factura');
    }
  };

  // ─── CREAR CLIENTE RAPIDO ───
  const validarIdentificacion = useCallback(async (ci, tipo) => {
    if (!ci || ci.length < 5) { setCiValidacion({ valido: null, existe: false }); return; }
    try {
      const res = await clientesAPI.validarCI({ identificacion: ci, tipo_identificacion: tipo });
      if (res.data.success) {
        setCiValidacion({ valido: res.data.data.valido, existe: res.data.data.existe });
        if (res.data.data.existe) {
          try {
            const busq = await clientesAPI.getAll({ buscar: ci, limit: 1 });
            if (busq.data.success && busq.data.data.length > 0) {
              toast.info('Cliente ya existe, seleccionado automaticamente');
              setClienteSeleccionado(busq.data.data[0]);
              setShowNuevoCliente(false);
              resetNuevoCliente();
            }
          } catch { /* silencioso */ }
        }
      }
    } catch { /* silencioso */ }
  }, []);

  const resetNuevoCliente = () => {
    setNuevoCliente({
      tipo_persona: 'natural', tipo_identificacion: 'cedula', identificacion: '',
      nombres: '', apellidos: '', razon_social: '', email: '', direccion: '', celular: ''
    });
    setCiValidacion({ valido: null, existe: false });
  };

  const crearClienteRapido = async () => {
    const nc = nuevoCliente;
    if (!nc.identificacion) { toast.error('Ingrese la identificacion'); return; }
    if (nc.tipo_persona === 'natural' && (!nc.nombres || !nc.apellidos)) {
      toast.error('Nombres y apellidos son requeridos'); return;
    }
    if (nc.tipo_persona === 'juridica' && !nc.razon_social) {
      toast.error('Razon social es requerida'); return;
    }
    if (ciValidacion.valido === false) { toast.error('Identificacion invalida'); return; }

    setCreandoCliente(true);
    try {
      const res = await clientesAPI.create(nc);
      if (res.data.success) {
        toast.success('Cliente creado exitosamente');
        setClienteSeleccionado(res.data.data);
        setShowNuevoCliente(false);
        resetNuevoCliente();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error al crear cliente');
    }
    setCreandoCliente(false);
  };

  // ─── LOADING ───
  if (loadingCaja) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 400 }}>
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  // ─── SIN CAJA ABIERTA ───
  if (!cajaActiva) {
    return (
      <div className="container-fluid">
        <div className="alert alert-warning text-center py-5">
          <i className="bi bi-exclamation-triangle fs-1 d-block mb-2"></i>
          <h5>No tienes caja abierta</h5>
          <p className="mb-3">Debes abrir tu caja en "Caja Registradora" antes de realizar ventas.</p>
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            <button className="btn btn-primary btn-lg" onClick={() => setShowAbrirCaja(true)}>
              <i className="bi bi-unlock me-2"></i>Abrir Caja Aqui
            </button>
            <a href="/caja" className="btn btn-outline-primary btn-lg">
              <i className="bi bi-cash-stack me-1"></i> Ir a Caja Registradora
            </a>
          </div>
        </div>
        <div className="mt-4">
          <button className="btn btn-outline-secondary" onClick={() => { cargarHistorial(); setShowHistorial(true); }}>
            <i className="bi bi-clock-history me-1"></i>Ver historial de ventas
          </button>
        </div>
        {showAbrirCaja && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title"><i className="bi bi-unlock me-2"></i>Abrir Caja</h5>
                  <button className="btn-close btn-close-white" onClick={() => setShowAbrirCaja(false)}></button>
                </div>
                <div className="modal-body">
                  <label className="form-label fw-semibold">Monto de Apertura (Fondo)</label>
                  <div className="input-group input-group-lg">
                    <span className="input-group-text">$</span>
                    <input type="number" className="form-control" value={montoApertura}
                      onChange={e => setMontoApertura(e.target.value)} placeholder="0.00" autoFocus />
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowAbrirCaja(false)}>Cancelar</button>
                  <button className="btn btn-primary" onClick={abrirCaja}>
                    <i className="bi bi-check-circle me-1"></i>Abrir Caja
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {renderHistorial()}
      </div>
    );
  }

  // ─── RENDER HISTORIAL ───
  function renderHistorial() {
    if (!showHistorial) return null;
    return (
      <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"><i className="bi bi-clock-history me-2"></i>Historial de Ventas</h5>
              <button className="btn-close" onClick={() => setShowHistorial(false)}></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="table-responsive">
                {/* [MIG-041] Filtro por estado de entrega */}
                <div className="d-flex gap-2 align-items-center mb-2 px-1">
                  <small className="text-muted">Filtrar:</small>
                  <div className="btn-group btn-group-sm" role="group">
                    <button type="button" className={`btn btn-sm ${filtroEntrega === 'todas' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setFiltroEntrega('todas')}>
                      Todas
                    </button>
                    <button type="button" className={`btn btn-sm ${filtroEntrega === 'entregadas' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setFiltroEntrega('entregadas')}>
                      <i className="bi bi-box2-heart me-1"></i>Entregadas
                    </button>
                    <button type="button" className={`btn btn-sm ${filtroEntrega === 'pendientes' ? 'btn-warning' : 'btn-outline-warning'}`} onClick={() => setFiltroEntrega('pendientes')}>
                      <i className="bi bi-clock-history me-1"></i>Pendientes de stock
                    </button>
                  </div>
                </div>
                <table className="table table-sm table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Codigo</th><th>Fecha</th><th>Cliente</th><th>Total</th><th>Pago</th><th>Estado</th><th>Factura</th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* FIX: null safety — guard ventas array and date */}
                    {(ventas || []).filter(v => {
                      // [MIG-041] Filtrar por estado_entrega segun selector.
                      if (filtroEntrega === 'pendientes') return v.estado_entrega === 'pendiente_stock';
                      if (filtroEntrega === 'entregadas') return !v.estado_entrega || v.estado_entrega === 'entregada';
                      return true;
                    }).map(v => (
                      <tr key={v.id} className={v.estado_entrega === 'pendiente_stock' ? 'table-warning' : ''}>
                        <td>
                          <strong className="fs-6">{v.codigo}</strong>
                          {v.numero_orden && <small className="text-primary fw-bold d-block">Orden: {v.numero_orden}</small>}
                          {/* [MIG-041] Badge entrega pendiente */}
                          {v.estado_entrega === 'pendiente_stock' && (
                            <span className="badge bg-warning text-dark ms-1" style={{ fontSize: '0.65rem' }}>
                              <i className="bi bi-clock-history"></i> Pend.
                            </span>
                          )}
                        </td>
                        <td>{v.created_at ? new Date(v.created_at).toLocaleString('es-EC', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—'}</td>
                        <td>{v.cliente_nombre || 'Consumidor Final'}</td>
                        <td className="fw-bold text-success">{formatCurrency(v.total)}</td>
                        <td>
                          <span className={`badge ${v.metodo_pago === 'efectivo' ? 'bg-success' : v.metodo_pago === 'tarjeta_medianet' ? 'bg-info' : v.metodo_pago === 'tarjeta_payphone' ? 'bg-danger' : v.metodo_pago === 'transferencia' ? 'bg-primary' : v.metodo_pago === 'mixto' ? 'bg-warning text-dark' : v.metodo_pago === 'credito' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                            <i className={`bi ${metodoIcon(v.metodo_pago)} me-1`}></i>
                            {metodoLabel(v.metodo_pago)}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${v.estado === 'completada' ? 'bg-success' : v.estado === 'anulada' ? 'bg-danger' : 'bg-warning'}`}>
                            {v.estado}
                          </span>
                        </td>
                        <td>
                          {v.facturada ? (
                            <span className="badge bg-primary bg-opacity-10 text-primary"><i className="bi bi-check-circle me-1"></i>SRI</span>
                          ) : v.estado === 'completada' ? (
                            /* [CF sin SRI] Consumidor Final no se factura: solo comprobante interno */
                            (v.cliente_id && v.cliente_ci !== '9999999999999') ? (
                              <button className="btn btn-sm btn-outline-primary py-0 px-1" onClick={() => generarFactura(v.id)}
                                title="Generar factura electronica">
                                <i className="bi bi-file-earmark-check"></i>
                              </button>
                            ) : (
                              <span className="badge bg-light text-muted" title="Consumidor Final: sin factura SRI — entregar comprobante interno">C.F.</span>
                            )
                          ) : <span className="text-muted">-</span>}
                        </td>
                        <td>
                          <div className="btn-group btn-group-sm">
                            <button className="btn btn-outline-primary" onClick={() => verDetalle(v.id)} title="Ver detalle">
                              <i className="bi bi-eye"></i>
                            </button>
                            <button className="btn btn-outline-secondary" onClick={() => cargarTicket(v.id)} title="Imprimir ticket">
                              <i className="bi bi-printer"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {ventas.length === 0 && <tr><td colSpan={8} className="text-center text-muted py-3">No hay ventas registradas</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ══════════════════════════════════════════
  // RENDER POS PRINCIPAL
  // ══════════════════════════════════════════
  return (
    <div className="container-fluid px-0">
      {/* Header con estado de caja + atajos */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          <span className="badge bg-success fs-6">
            <i className="bi bi-check-circle me-1"></i>Caja Abierta
          </span>
          <small className="text-muted">
            {cajaActiva.codigo} | Apertura: {formatCurrency(cajaActiva.monto_apertura)}
          </small>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <small className="text-muted d-none d-lg-block">
            <kbd>F2</kbd> Buscar &nbsp; <kbd>F5</kbd> Cobrar &nbsp; <kbd>F8</kbd> Historial &nbsp; <kbd>ESC</kbd> Cerrar
          </small>
          <button className="btn btn-sm btn-outline-primary" onClick={() => { cargarHistorial(); setShowHistorial(true); }}>
            <i className="bi bi-clock-history me-1"></i>Historial
          </button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => setShowCerrarCaja(true)}>
            <i className="bi bi-lock me-1"></i>Cerrar Caja
          </button>
        </div>
      </div>

      <div className="row g-3">
        {/* ─── LADO IZQUIERDO: BUSQUEDA + CARRITO ─── */}
        <div className="col-lg-7">
          <div className="card mb-3">
            <div className="card-body p-2">
              <div className="position-relative">
                <div className="input-group">
                  <span className="input-group-text bg-primary text-white"><i className="bi bi-search"></i></span>
                  <input ref={busquedaRef} type="text" className="form-control form-control-lg"
                    placeholder="Buscar producto o escanear codigo de barras... (F2)"
                    value={buscarProducto}
                    onChange={e => setBuscarProducto(e.target.value)}
                    onKeyDown={handleBusquedaKeyDown}
                    autoFocus
                  />
                  {buscandoProducto && (
                    <span className="input-group-text">
                      <div className="spinner-border spinner-border-sm text-primary"></div>
                    </span>
                  )}
                </div>
                {productosResultados.length > 0 && (
                  <div className="list-group position-absolute w-100 shadow-lg" style={{ zIndex: 1050, maxHeight: 350, overflowY: 'auto' }}>
                    {productosResultados.map(p => (
                      <button key={p.id} className="list-group-item list-group-item-action py-2" onClick={() => agregarAlCarrito(p)}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <strong>{p.nombre}</strong><br />
                            <small className="text-muted">{p.codigo} | Stock: {p.stock_actual}</small>
                          </div>
                          <div className="text-end">
                            {parseFloat(p.precio_venta) > 0
                              ? <span className="fs-5 fw-bold text-primary">{formatCurrency(p.precio_venta)}</span>
                              : <span className="badge bg-warning text-dark"><i className="bi bi-exclamation-triangle-fill me-1"></i>Sin precio</span>}
                            {parseInt(p.stock_actual) <= 0 && <><br /><span className="badge bg-danger">Sin stock</span></>}
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Carrito */}
          <div className="card">
            <div className="card-header bg-light d-flex justify-content-between align-items-center py-2">
              <strong><i className="bi bi-cart3 me-2"></i>Detalle de Venta ({carrito.length} items)</strong>
              {carrito.length > 0 && (
                <button className="btn btn-sm btn-outline-danger" onClick={() => setCarrito([])}>
                  <i className="bi bi-trash me-1"></i>Limpiar
                </button>
              )}
            </div>
            <div className="card-body p-0">
              <div className="table-responsive" style={{ maxHeight: 400, overflowY: 'auto' }}>
                <table className="table table-sm table-hover mb-0 align-middle">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th>Producto</th>
                      <th style={{ width: 80 }}>Precio</th>
                      <th style={{ width: 70 }}>Cant.</th>
                      <th style={{ width: 70 }}>Desc.%</th>
                      <th style={{ width: 100 }} className="text-end">Subtotal</th>
                      <th style={{ width: 40 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {carrito.map((item, idx) => {
                      const sub = item.precio_unitario * item.cantidad * (1 - item.descuento_porcentaje / 100);
                      return (
                        <tr key={idx}>
                          <td>
                            <div className="fw-semibold">{item.nombre}</div>
                            <small className="text-muted">{item.codigo}</small>
                          </td>
                          <td>
                            <input type="number" className={`form-control form-control-sm ${parseFloat(item.precio_unitario) > 0 ? '' : 'border-danger bg-danger bg-opacity-10'}`} step="0.01"
                              value={item.precio_unitario}
                              onChange={e => actualizarItem(idx, 'precio_unitario', e.target.value)} />
                            {parseFloat(item.precio_unitario) <= 0 && (
                              <small className="text-danger d-block" style={{ fontSize: '0.7rem', lineHeight: 1.1 }}>
                                <i className="bi bi-exclamation-triangle-fill me-1"></i>Sin precio: ingrésalo
                              </small>
                            )}
                          </td>
                          <td>
                            {/* [Venta sin stock] Sin tope por stock: se puede facturar mas que el stock; el faltante se descuenta al reponer. */}
                            <input type="number" className="form-control form-control-sm" min="1"
                              value={item.cantidad}
                              onChange={e => actualizarItem(idx, 'cantidad', e.target.value)} />
                          </td>
                          <td>
                            <input type="number" className="form-control form-control-sm" min="0" max="100" step="1"
                              value={item.descuento_porcentaje}
                              onChange={e => actualizarItem(idx, 'descuento_porcentaje', e.target.value)} />
                          </td>
                          <td className="text-end fw-bold">{formatCurrency(sub)}</td>
                          <td>
                            <button className="btn btn-sm btn-outline-danger p-1" onClick={() => eliminarItem(idx)}>
                              <i className="bi bi-x"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    {carrito.length === 0 && (
                      <tr>
                        <td colSpan={6} className="text-center text-muted py-5">
                          <i className="bi bi-cart display-4 d-block mb-2"></i>
                          Busque y agregue productos <small>(F2 o escanee codigo)</small>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* ─── LADO DERECHO: RESUMEN + PAGO ─── */}
        <div className="col-lg-5">
          {/* [MIG-041] Banner persistente: modo entrega pendiente activo */}
          {entregaPendiente && (
            <div className="alert alert-warning d-flex justify-content-between align-items-center py-2 mb-2" style={{ fontSize: '0.85rem' }}>
              <div>
                <i className="bi bi-clock-history me-1"></i>
                <strong>Modo Entrega Pendiente</strong> — el stock no se descontará al cobrar
                <div className="mt-1 d-flex align-items-center gap-2">
                  <label className="small mb-0 text-nowrap">Fecha límite:</label>
                  <input type="date" className="form-control form-control-sm py-0" style={{ maxWidth: 150, fontSize: '0.8rem' }}
                    value={fechaLimiteEntrega} min={new Date().toISOString().slice(0, 10)}
                    onChange={e => setFechaLimiteEntrega(e.target.value)} />
                </div>
              </div>
              <button type="button" className="btn btn-sm btn-link text-danger p-0"
                title="Cancelar modo entrega pendiente"
                onClick={() => { setEntregaPendiente(false); setFechaLimiteEntrega(''); }}>
                <i className="bi bi-x-circle fs-5"></i>
              </button>
            </div>
          )}

          {/* Cliente */}
          <div className="card mb-3">
            <div className="card-body p-2">
              {clienteSeleccionado ? (
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <i className={`bi ${clienteSeleccionado.tipo_persona === 'juridica' ? 'bi-building' : 'bi-person-fill'} text-primary me-1`}></i>
                    <strong>
                      {clienteSeleccionado.tipo_persona === 'juridica'
                        ? (clienteSeleccionado.razon_social || clienteSeleccionado.nombres)
                        : `${clienteSeleccionado.nombres} ${clienteSeleccionado.apellidos || ''}`}
                    </strong><br />
                    <small className="text-muted">
                      {(clienteSeleccionado.tipo_identificacion || '').toUpperCase()}: {clienteSeleccionado.identificacion}
                      {clienteSeleccionado.tipo_persona === 'juridica' && (
                        <span className="badge bg-info bg-opacity-10 text-info ms-1" style={{fontSize: '0.6rem'}}>Juridica</span>
                      )}
                    </small>
                  </div>
                  <button className="btn btn-sm btn-outline-danger"
                    onClick={() => { setClienteSeleccionado(null); setBuscarCliente(''); }}>
                    <i className="bi bi-x"></i>
                  </button>
                </div>
              ) : (
                <div className="position-relative">
                  <div className="d-flex gap-2 align-items-center">
                    <div className="input-group input-group-sm flex-grow-1">
                      <span className="input-group-text"><i className="bi bi-person"></i></span>
                      <input type="text" className="form-control" placeholder="Buscar cliente por CI, nombre..."
                        value={buscarCliente} onChange={e => setBuscarCliente(e.target.value)} />
                    </div>
                    <button className="btn btn-sm btn-outline-secondary text-nowrap"
                      title="Consumidor Final (9999999999999)"
                      onClick={() => setClienteSeleccionado({
                        id: 1, nombres: 'CONSUMIDOR', apellidos: 'FINAL',
                        identificacion: '9999999999999', tipo_identificacion: 'ruc', tipo_persona: 'natural'
                      })}>
                      <i className="bi bi-person-x me-1"></i>C. Final
                    </button>
                    <button className="btn btn-sm btn-outline-success text-nowrap"
                      title="Crear cliente rapido para facturacion"
                      onClick={() => setShowNuevoCliente(true)}>
                      <i className="bi bi-person-plus me-1"></i>Nuevo
                    </button>
                  </div>
                  {clienteResultados.length > 0 && (
                    <div className="list-group position-absolute w-100 shadow-lg" style={{ zIndex: 1050 }}>
                      {clienteResultados.map(c => (
                        <button key={c.id} className="list-group-item list-group-item-action py-1 small"
                          onClick={() => { setClienteSeleccionado(c); setClienteResultados([]); setBuscarCliente(''); }}>
                          <strong>
                            {c.tipo_persona === 'juridica' ? (c.razon_social || c.nombres) : `${c.nombres} ${c.apellidos || ''}`}
                          </strong>
                          {' - '}{(c.tipo_identificacion || '').toUpperCase()}: {c.identificacion}
                          {c.tipo_persona === 'juridica' && <span className="badge bg-info bg-opacity-10 text-info ms-1">Juridica</span>}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Resumen de Totales */}
          <div className="card mb-3">
            <div className="card-body">
              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal (IVA 0%)</span>
                <span>{formatCurrency(totales.subtotal0)}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal (con IVA)</span>
                <span>{formatCurrency(totales.subtotalIva)}</span>
              </div>
              {totales.descuentoItems > 0 && (
                <div className="d-flex justify-content-between mb-2 text-danger">
                  <span>Desc. Items</span>
                  <span>-{formatCurrency(totales.descuentoItems)}</span>
                </div>
              )}
              <div className="d-flex justify-content-between mb-2">
                <span>IVA</span>
                <span>{formatCurrency(totales.iva)}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Desc. Global</span>
                <div className="input-group input-group-sm" style={{ width: 100 }}>
                  <span className="input-group-text p-1">$</span>
                  <input type="number" className="form-control form-control-sm p-1" step="0.01"
                    value={descuentoGlobal} onChange={e => setDescuentoGlobal(e.target.value)} />
                </div>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span className="fs-4 fw-bold">TOTAL</span>
                <span className="fs-4 fw-bold text-primary">{formatCurrency(totales.total)}</span>
              </div>
            </div>
          </div>

          {/* [N° orden física] Visible al facturar, sincronizado con el modal de pago */}
          <div className="mb-2">
            <div className="input-group input-group-sm">
              <span className="input-group-text"><i className="bi bi-hash"></i></span>
              <input type="text" className="form-control" placeholder="N° Orden física (opcional)"
                maxLength={50} value={numeroOrden} onChange={e => setNumeroOrden(e.target.value)} />
            </div>
          </div>

          {/* Boton Cobrar */}
          <div className="d-grid gap-2">
            <button className="btn btn-success btn-lg" disabled={carrito.length === 0 || modoEspectador}
              onClick={abrirModalPago}>
              <i className="bi bi-cash-coin me-2"></i>{modoEspectador ? 'Modo Espectador' : <>Cobrar {formatCurrency(totales.total)} <small className="ms-2">(F5)</small></>}
            </button>
          </div>

          {/* Resumen turno */}
          {cajaActiva?.resumen_ventas && (
            <div className="card mt-3">
              <div className="card-body py-2">
                <small className="text-muted fw-semibold">Resumen del Turno</small>
                <div className="row g-1 mt-1">
                  <div className="col-6">
                    <small>Ventas: <strong>{formatNumber(cajaActiva.resumen_ventas.total_ventas)}</strong></small>
                  </div>
                  <div className="col-6 text-end">
                    <small>Total: <strong className="text-success">{formatCurrency(cajaActiva.resumen_ventas.total_monto)}</strong></small>
                  </div>
                </div>
                {parseFloat(cajaActiva.resumen_servicios?.total_servicios || 0) > 0 && (
                  <div className="row g-1">
                    <div className="col-6">
                      <small className="text-muted">Servicios: <strong>{formatNumber(cajaActiva.resumen_servicios.num_servicios)}</strong></small>
                    </div>
                    <div className="col-6 text-end">
                      <small className="text-muted">{formatCurrency(cajaActiva.resumen_servicios.total_servicios)}</small>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════════ */}
      {/* MODAL DE PAGO PROFESIONAL */}
      {/* ═══════════════════════════════════════════════════════ */}
      {showPagoModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-success text-white">
                <h5 className="modal-title"><i className="bi bi-cash-coin me-2"></i>Procesar Pago</h5>
                <button className="btn-close btn-close-white" onClick={() => setShowPagoModal(false)}></button>
              </div>
              <div className="modal-body">
                {/* Total grande */}
                <div className="text-center mb-3">
                  <span className="display-4 fw-bold text-primary">{formatCurrency(totales.total)}</span>
                </div>

                {/* [Elección obligatoria 1/2] CLIENTE: Consumidor Final o con datos */}
                <div className="mb-3">
                  <label className="form-label fw-semibold small mb-1"><i className="bi bi-person me-1"></i>Cliente <span className="text-danger">*</span></label>
                  {clienteSeleccionado ? (
                    <div className={`alert py-2 mb-0 d-flex justify-content-between align-items-center ${clienteSeleccionado.identificacion === '9999999999999' ? 'alert-secondary' : 'alert-success'}`}>
                      <span>
                        {clienteSeleccionado.identificacion === '9999999999999'
                          ? <><i className="bi bi-person-x me-1"></i><strong>CONSUMIDOR FINAL</strong></>
                          : <><i className="bi bi-person-check me-1"></i><strong>{clienteSeleccionado.tipo_persona === 'juridica'
                              ? (clienteSeleccionado.razon_social || clienteSeleccionado.nombres)
                              : `${clienteSeleccionado.nombres} ${clienteSeleccionado.apellidos || ''}`}</strong> — {clienteSeleccionado.identificacion}</>}
                      </span>
                      <button className="btn btn-sm btn-outline-secondary" title="Cambiar cliente"
                        onClick={() => { setClienteSeleccionado(null); setFacturarSRI(null); }}>
                        <i className="bi bi-arrow-repeat me-1"></i>Cambiar
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-secondary flex-fill"
                        onClick={() => {
                          setClienteSeleccionado({
                            id: 1, nombres: 'CONSUMIDOR', apellidos: 'FINAL',
                            identificacion: '9999999999999', tipo_identificacion: 'ruc', tipo_persona: 'natural'
                          });
                          setFacturarSRI(false);
                        }}>
                        <i className="bi bi-person-x me-1"></i>Consumidor Final
                      </button>
                      <button className="btn btn-outline-primary flex-fill"
                        onClick={() => { setShowPagoModal(false); toast.info('Busque o cree el cliente en el panel superior y vuelva a Cobrar.'); }}>
                        <i className="bi bi-person-vcard me-1"></i>Con datos de cliente
                      </button>
                    </div>
                  )}
                </div>

                {/* [Elección obligatoria 2/2] FACTURACIÓN: con SRI o sin SRI */}
                <div className="mb-3">
                  <label className="form-label fw-semibold small mb-1"><i className="bi bi-receipt me-1"></i>Facturación <span className="text-danger">*</span></label>
                  {!clienteSeleccionado ? (
                    <div className="text-muted small">Elija primero el cliente.</div>
                  ) : clienteSeleccionado.identificacion === '9999999999999' ? (
                    <div className="alert alert-secondary py-2 mb-0">
                      <i className="bi bi-printer me-1"></i>SIN factura SRI — se entrega <strong>comprobante interno</strong> (Consumidor Final).
                    </div>
                  ) : (
                    <div className="d-flex gap-2">
                      <button className={`btn flex-fill ${facturarSRI === true ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setFacturarSRI(true)}>
                        <i className="bi bi-file-earmark-check me-1"></i>Facturar CON SRI
                      </button>
                      <button className={`btn flex-fill ${facturarSRI === false ? 'btn-dark' : 'btn-outline-dark'}`}
                        onClick={() => setFacturarSRI(false)}>
                        <i className="bi bi-printer me-1"></i>SIN SRI (comprobante interno)
                      </button>
                    </div>
                  )}
                  {clienteSeleccionado && clienteSeleccionado.identificacion !== '9999999999999' && facturarSRI === null && (
                    <div className="small text-danger mt-1"><i className="bi bi-exclamation-circle me-1"></i>Debe elegir una opción para continuar.</div>
                  )}
                </div>

                {/* [N° orden física] Código de la orden de papel (opcional) */}
                <div className="mb-3">
                  <label className="form-label fw-semibold small"><i className="bi bi-hash me-1"></i>N° Orden física (opcional)</label>
                  <input type="text" className="form-control" placeholder="Código de la orden de papel"
                    value={numeroOrden} maxLength={50}
                    onChange={e => setNumeroOrden(e.target.value)} />
                </div>

                {/* Selector de modo: Simple vs Mixto */}
                <div className="d-flex gap-2 mb-3">
                  <button className={`btn flex-fill ${!pagoMixtoActivo ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => { setPagoMixtoActivo(false); setPagosMixtos([]); setEsCredito(false); setFechaVencimientoCredito(''); setMetodoPago('efectivo'); }}>
                    <i className="bi bi-wallet me-1"></i>Pago Simple
                  </button>
                  <button className={`btn flex-fill ${pagoMixtoActivo ? 'btn-warning' : 'btn-outline-warning'}`}
                    onClick={() => { setPagoMixtoActivo(true); setEsCredito(false); setFechaVencimientoCredito(''); }}>
                    <i className="bi bi-layers me-1"></i>Pago Mixto
                  </button>
                </div>

                {/* ─── PAGO SIMPLE ─── */}
                {!pagoMixtoActivo && (
                  <>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Metodo de Pago</label>
                      <div className="d-flex gap-2 flex-wrap">
                        {[
                          { val: 'efectivo', icon: 'bi-cash', label: 'Efectivo', color: 'success' },
                          { val: 'transferencia', icon: 'bi-bank', label: 'Transfer.', color: 'primary' }
                        ].map(m => (
                          <button key={m.val}
                            className={`btn flex-fill ${metodoPago === m.val && !esCredito ? `btn-${m.color}` : `btn-outline-${m.color}`}`}
                            onClick={() => { setMetodoPago(m.val); setEsCredito(false); if (m.val === 'efectivo' && !montoRecibido) setMontoRecibido((parseFloat(totales.total) || 0).toFixed(2)); }}>
                            <i className={`bi ${m.icon} me-1`}></i>{m.label}
                          </button>
                        ))}
                        {medianetEnabled && (
                          <button
                            className={`btn flex-fill ${metodoPago === 'tarjeta_medianet' && !esCredito ? 'btn-info' : 'btn-outline-info'}`}
                            onClick={() => { setMetodoPago('tarjeta_medianet'); setEsCredito(false); }}>
                            <i className="bi bi-credit-card-2-front me-1"></i>Medianet
                          </button>
                        )}
                        {payphoneEnabled && (
                          <button
                            className={`btn flex-fill ${metodoPago === 'tarjeta_payphone' && !esCredito ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => { setMetodoPago('tarjeta_payphone'); setEsCredito(false); }}>
                            <i className="bi bi-phone me-1"></i>Payphone
                          </button>
                        )}
                        <button className={`btn flex-fill ${esCredito ? 'btn-warning' : 'btn-outline-warning'}`}
                          onClick={() => {
                            if (!esCredito) {
                              setEsCredito(true);
                              // Default: 30 días para vencimiento
                              const d = new Date(); d.setDate(d.getDate() + 30);
                              setFechaVencimientoCredito(d.toISOString().split('T')[0]);
                            } else {
                              setEsCredito(false);
                              setFechaVencimientoCredito('');
                              setMetodoPago('efectivo');
                            }
                          }}>
                          <i className="bi bi-calendar3 me-1"></i>Crédito
                        </button>
                      </div>
                    </div>

                    {/* ─── SECCIÓN CRÉDITO ─── */}
                    {esCredito && (
                      <div className="card border-warning mb-3" style={{ backgroundColor: '#fff8e1' }}>
                        <div className="card-body py-3">
                          <h6 className="mb-3"><i className="bi bi-calendar3 text-warning me-2"></i>Venta a Crédito</h6>
                          {!clienteSeleccionado && (
                            <div className="alert alert-danger py-2 mb-3">
                              <i className="bi bi-exclamation-triangle me-1"></i>
                              <strong>Debe seleccionar un cliente</strong> para ventas a crédito
                            </div>
                          )}

                          {/* Abono Inicial Obligatorio */}
                          <div className="mb-3">
                            <label className="form-label fw-semibold">
                              <i className="bi bi-cash-coin text-success me-1"></i>Abono Inicial *
                            </label>
                            <div className="input-group">
                              <span className="input-group-text">$</span>
                              <input type="number" className="form-control" step="0.01" min="0.01"
                                max={totales.total - 0.01}
                                value={abonoInicial}
                                onChange={e => setAbonoInicial(e.target.value)}
                                placeholder="Monto del abono inicial" autoFocus />
                            </div>
                            {parseFloat(abonoInicial) > 0 && (
                              <div className="mt-1 small">
                                <span className="text-success">Abono: <strong>{formatCurrency(parseFloat(abonoInicial))}</strong></span>
                                <span className="text-muted mx-2">|</span>
                                <span className="text-danger">Saldo pendiente: <strong>{formatCurrency(Math.max(0, totales.total - parseFloat(abonoInicial)))}</strong></span>
                              </div>
                            )}
                          </div>

                          {/* Método de pago del abono */}
                          <div className="mb-3">
                            <label className="form-label small fw-semibold">Método de Pago del Abono</label>
                            <div className="d-flex gap-2">
                              {[
                                { value: 'efectivo', label: 'Efectivo', icon: 'bi-cash', color: 'success' },
                                { value: 'tarjeta_medianet', label: 'Tarjeta', icon: 'bi-credit-card', color: 'info' },
                                { value: 'transferencia', label: 'Transfer.', icon: 'bi-bank', color: 'primary' }
                              ].map(m => (
                                <button key={m.value}
                                  className={`btn btn-sm ${abonoInicialMetodo === m.value ? `btn-${m.color}` : `btn-outline-${m.color}`} flex-fill`}
                                  onClick={() => setAbonoInicialMetodo(m.value)}>
                                  <i className={`bi ${m.icon} me-1`}></i>{m.label}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Campos Medianet para abono inicial */}
                          {abonoInicialMetodo === 'tarjeta_medianet' && (
                            <div className="border rounded p-2 mb-3" style={{ backgroundColor: '#f0f8ff' }}>
                              <div className="row g-2">
                                <div className="col-6">
                                  <label className="form-label small">Cod. Autorización *</label>
                                  <input type="text" className="form-control form-control-sm"
                                    value={abonoInicialMedianet.codigo_autorizacion}
                                    onChange={e => setAbonoInicialMedianet({...abonoInicialMedianet, codigo_autorizacion: e.target.value})}
                                    placeholder="123456" />
                                </div>
                                <div className="col-6">
                                  <label className="form-label small">Últimos 4 dígitos</label>
                                  <input type="text" className="form-control form-control-sm" maxLength={4}
                                    value={abonoInicialMedianet.ultimos_digitos}
                                    onChange={e => setAbonoInicialMedianet({...abonoInicialMedianet, ultimos_digitos: e.target.value.replace(/\D/g, '')})}
                                    placeholder="1234" />
                                </div>
                                <div className="col-6">
                                  <label className="form-label small">Marca</label>
                                  <select className="form-select form-select-sm" value={abonoInicialMedianet.marca_tarjeta}
                                    onChange={e => setAbonoInicialMedianet({...abonoInicialMedianet, marca_tarjeta: e.target.value})}>
                                    <option>Visa</option><option>Mastercard</option><option>Amex</option><option>Discover</option>
                                  </select>
                                </div>
                                <div className="col-6">
                                  <label className="form-label small">Tipo</label>
                                  <select className="form-select form-select-sm" value={abonoInicialMedianet.tipo_tarjeta}
                                    onChange={e => setAbonoInicialMedianet({...abonoInicialMedianet, tipo_tarjeta: e.target.value})}>
                                    <option value="credito">Crédito</option><option value="debito">Débito</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="mb-2">
                            <label className="form-label small fw-semibold">Fecha de Vencimiento</label>
                            <input type="date" className="form-control form-control-sm"
                              value={fechaVencimientoCredito}
                              onChange={e => setFechaVencimientoCredito(e.target.value)}
                              min={new Date().toISOString().split('T')[0]} />
                          </div>
                          <div className="alert alert-info py-2 mb-0 small">
                            <i className="bi bi-info-circle me-1"></i>
                            Se registrará el abono inicial y el saldo restante se podrá cobrar mediante abonos parciales desde Cuentas por Cobrar.
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Campos segun metodo */}
                    {metodoPago === 'efectivo' && !esCredito && (
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Monto Recibido</label>
                        <div className="input-group input-group-lg">
                          <span className="input-group-text">$</span>
                          <input type="number" className="form-control" step="0.01"
                            value={montoRecibido} onChange={e => setMontoRecibido(e.target.value)} autoFocus />
                        </div>
                        <div className="d-flex gap-1 mt-2 flex-wrap">
                          {[1, 5, 10, 20, 50, 100].map(b => (
                            <button key={b} className="btn btn-sm btn-outline-secondary"
                              onClick={() => setMontoRecibido((parseFloat(montoRecibido || 0) + b).toFixed(2))}>
                              +${b}
                            </button>
                          ))}
                          <button className="btn btn-sm btn-outline-primary"
                            onClick={() => setMontoRecibido((parseFloat(totales.total) || 0).toFixed(2))}>Exacto</button>
                        </div>
                        {parseFloat(montoRecibido) >= totales.total && (
                          <div className="alert alert-success mt-2 py-2 text-center">
                            <strong>Cambio: {formatCurrency(parseFloat(montoRecibido) - totales.total)}</strong>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Medianet - campos de terminal */}
                    {metodoPago === 'tarjeta_medianet' && !esCredito && (
                      <div className="card bg-light mb-3">
                        <div className="card-body py-3">
                          <h6 className="mb-3"><i className="bi bi-credit-card-2-front text-info me-2"></i>Datos Terminal Medianet</h6>
                          <div className="row g-2">
                            <div className="col-6">
                              <label className="form-label small fw-semibold">Cod. Autorizacion *</label>
                              <input type="text" className="form-control form-control-sm"
                                value={medianetData.codigo_autorizacion}
                                onChange={e => setMedianetData({...medianetData, codigo_autorizacion: e.target.value})}
                                placeholder="Ej: 123456" autoFocus />
                            </div>
                            <div className="col-6">
                              <label className="form-label small fw-semibold">Ultimos 4 digitos</label>
                              <input type="text" className="form-control form-control-sm" maxLength={4}
                                value={medianetData.ultimos_digitos}
                                onChange={e => setMedianetData({...medianetData, ultimos_digitos: e.target.value.replace(/\D/g, '')})}
                                placeholder="1234" />
                            </div>
                            <div className="col-6">
                              <label className="form-label small fw-semibold">Marca</label>
                              <select className="form-select form-select-sm" value={medianetData.marca_tarjeta}
                                onChange={e => setMedianetData({...medianetData, marca_tarjeta: e.target.value})}>
                                <option value="Visa">Visa</option>
                                <option value="Mastercard">Mastercard</option>
                                <option value="Amex">American Express</option>
                                <option value="UnionPay">Union Pay</option>
                                <option value="Discover">Discover</option>
                                <option value="Otra">Otra</option>
                              </select>
                            </div>
                            <div className="col-6">
                              <label className="form-label small fw-semibold">Tipo</label>
                              <select className="form-select form-select-sm" value={medianetData.tipo_tarjeta}
                                onChange={e => setMedianetData({...medianetData, tipo_tarjeta: e.target.value})}>
                                <option value="credito">Credito</option>
                                <option value="debito">Debito</option>
                              </select>
                            </div>
                          </div>
                          <div className="alert alert-info py-1 mt-2 mb-0 small">
                            <i className="bi bi-info-circle me-1"></i>
                            Ingrese los datos del voucher generado por la terminal Medianet
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Payphone - boton de redireccion */}
                    {metodoPago === 'tarjeta_payphone' && !esCredito && (
                      <div className="card bg-light mb-3">
                        <div className="card-body py-3 text-center">
                          <h6 className="mb-2"><i className="bi bi-phone text-danger me-2"></i>Pago con Payphone</h6>
                          <p className="small text-muted mb-3">
                            Se redirigira a la plataforma de Payphone para procesar el pago con tarjeta de forma segura.
                          </p>
                          <button className="btn btn-danger btn-lg" onClick={iniciarPagoPayphone}
                            disabled={payphoneLoading}>
                            {payphoneLoading ? (
                              <><span className="spinner-border spinner-border-sm me-2"></span>Conectando...</>
                            ) : (
                              <><i className="bi bi-shield-check me-2"></i>Pagar con Payphone {formatCurrency(totales.total)}</>
                            )}
                          </button>
                          <div className="mt-2 small text-muted">
                            <i className="bi bi-lock me-1"></i>Pago seguro procesado por Payphone Ecuador
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* ─── PAGO MIXTO ─── */}
                {pagoMixtoActivo && (
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="form-label fw-semibold mb-0">Agregar Pagos</label>
                      <span className={`badge ${restanteMixto > 0.01 ? 'bg-warning text-dark' : 'bg-success'} fs-6`}>
                        {restanteMixto > 0.01 ? `Restante: ${formatCurrency(restanteMixto)}` : 'Monto cubierto'}
                      </span>
                    </div>

                    {/* Botones para agregar pago mixto */}
                    <div className="d-flex gap-1 flex-wrap mb-3">
                      <button className="btn btn-sm btn-outline-success" onClick={() => agregarPagoMixto('efectivo')}>
                        <i className="bi bi-cash me-1"></i>+ Efectivo
                      </button>
                      {medianetEnabled && (
                        <button className="btn btn-sm btn-outline-info" onClick={() => agregarPagoMixto('tarjeta_medianet')}>
                          <i className="bi bi-credit-card-2-front me-1"></i>+ Medianet
                        </button>
                      )}
                      <button className="btn btn-sm btn-outline-primary" onClick={() => agregarPagoMixto('transferencia')}>
                        <i className="bi bi-bank me-1"></i>+ Transferencia
                      </button>
                    </div>

                    {/* Lista de pagos mixtos */}
                    {pagosMixtos.map((pago, idx) => (
                      <div key={idx} className="card mb-2">
                        <div className="card-body py-2 px-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="badge bg-secondary">
                              <i className={`bi ${metodoIcon(pago.metodo)} me-1`}></i>{metodoLabel(pago.metodo)}
                            </span>
                            <button className="btn btn-sm btn-outline-danger py-0 px-1" onClick={() => eliminarPagoMixto(idx)}>
                              <i className="bi bi-x"></i>
                            </button>
                          </div>
                          <div className="row g-2">
                            <div className={pago.metodo === 'tarjeta_medianet' ? 'col-3' : 'col-12'}>
                              <div className="input-group input-group-sm">
                                <span className="input-group-text">$</span>
                                <input type="number" className="form-control" step="0.01"
                                  value={pago.monto}
                                  onChange={e => actualizarPagoMixto(idx, 'monto', e.target.value)} />
                              </div>
                            </div>
                            {pago.metodo === 'tarjeta_medianet' && (
                              <>
                                <div className="col-3">
                                  <input type="text" className="form-control form-control-sm"
                                    placeholder="Cod. Autoriz. *"
                                    value={pago.codigo_autorizacion}
                                    onChange={e => actualizarPagoMixto(idx, 'codigo_autorizacion', e.target.value)} />
                                </div>
                                <div className="col-2">
                                  <input type="text" className="form-control form-control-sm" maxLength={4}
                                    placeholder="4 dig."
                                    value={pago.ultimos_digitos}
                                    onChange={e => actualizarPagoMixto(idx, 'ultimos_digitos', e.target.value.replace(/\D/g, ''))} />
                                </div>
                                <div className="col-2">
                                  <select className="form-select form-select-sm"
                                    value={pago.marca_tarjeta || 'Visa'}
                                    onChange={e => actualizarPagoMixto(idx, 'marca_tarjeta', e.target.value)}>
                                    <option value="Visa">Visa</option>
                                    <option value="Mastercard">MC</option>
                                    <option value="Amex">Amex</option>
                                    <option value="UnionPay">UPay</option>
                                    <option value="Discover">Disc.</option>
                                  </select>
                                </div>
                                <div className="col-2">
                                  <select className="form-select form-select-sm"
                                    value={pago.tipo_tarjeta || 'credito'}
                                    onChange={e => actualizarPagoMixto(idx, 'tipo_tarjeta', e.target.value)}>
                                    <option value="credito">Cred.</option>
                                    <option value="debito">Deb.</option>
                                  </select>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                    {pagosMixtos.length === 0 && (
                      <div className="text-center text-muted py-3">
                        <i className="bi bi-layers display-6 d-block mb-1"></i>
                        <small>Agregue metodos de pago para cubrir el total</small>
                      </div>
                    )}

                    {/* Barra de progreso */}
                    <div className="progress mt-2" style={{ height: 8 }}>
                      <div className={`progress-bar ${totalPagosMixtos >= totales.total - 0.01 ? 'bg-success' : 'bg-warning'}`}
                        style={{ width: `${Math.min(100, (totalPagosMixtos / totales.total) * 100)}%` }}></div>
                    </div>
                    <div className="d-flex justify-content-between mt-1">
                      <small className="text-muted">Pagado: {formatCurrency(totalPagosMixtos)}</small>
                      <small className="text-muted">Total: {formatCurrency(totales.total)}</small>
                    </div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowPagoModal(false)}>
                  Cancelar <small>(ESC)</small>
                </button>
                {/* Solo mostrar boton confirmar si no es payphone (payphone tiene su propio boton) */}
                {(esCredito || metodoPago !== 'tarjeta_payphone') && (
                  <button className={`btn ${esCredito ? 'btn-warning' : 'btn-success'} btn-lg`} onClick={procesarVenta}
                    disabled={procesando || (pagoMixtoActivo && totalPagosMixtos < totales.total - 0.01) || (esCredito && !clienteSeleccionado)
                      || !clienteSeleccionado
                      || (clienteSeleccionado.identificacion !== '9999999999999' && facturarSRI === null)}>
                    {procesando ? (
                      <><span className="spinner-border spinner-border-sm me-2"></span>Procesando...</>
                    ) : esCredito ? (
                      <><i className="bi bi-calendar3 me-2"></i>Registrar Venta a Crédito</>
                    ) : (
                      <><i className="bi bi-check-circle me-2"></i>Confirmar Venta</>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════════════════════════════════════════════ */}
      {/* MODAL TICKET DE VENTA */}
      {/* ═══════════════════════════════════════════════════════ */}
      {showTicket && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title"><i className="bi bi-receipt me-2"></i>Ticket de Venta</h5>
                <button className="btn-close" onClick={() => setShowTicket(null)}></button>
              </div>
              <div className="modal-body">
                {/* Preview del ticket */}
                <div className="bg-white border rounded p-3" style={{ fontFamily: "'Courier New', monospace", fontSize: 12 }}>
                  {showTicket.negocio.mostrar_logo && showTicket.negocio.logo_url && (
                    <div className="text-center mb-2">
                      <img
                        src={getImageUrl(showTicket.negocio.logo_url)}
                        alt="Logo"
                        style={{ maxWidth: showTicket.negocio.logo_ancho || 120, objectFit: 'contain', filter: 'grayscale(100%) contrast(1.2)' }}
                      />
                    </div>
                  )}
                  <div className="text-center fw-bold" style={{ fontSize: 14 }}>{showTicket.negocio.nombre}</div>
                  {showTicket.negocio.ruc && <div className="text-center small">RUC: {showTicket.negocio.ruc}</div>}
                  {showTicket.negocio.direccion && <div className="text-center small">{showTicket.negocio.direccion}</div>}
                  {showTicket.negocio.sucursal && <div className="text-center small">Suc: {showTicket.negocio.sucursal}</div>}
                  <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                  <div className="text-center fw-bold">NOTA DE VENTA</div>
                  <div className="fw-bold">No: {showTicket.venta.codigo}</div>
                  {showTicket.venta.numero_orden && <div className="fw-bold">Orden física: {showTicket.venta.numero_orden}</div>}
                  {showTicket.venta.ordenes_codigos && <div>Orden trab.: {showTicket.venta.ordenes_codigos}</div>}
                  <div>Fecha: {showTicket.venta.fecha ? new Date(showTicket.venta.fecha).toLocaleString('es-EC') : '—'}</div>
                  <div>Vendedor: {showTicket.venta.vendedor || '-'}</div>
                  <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                  <div>Cliente: {showTicket.cliente.nombre}</div>
                  <div>CI/RUC: {showTicket.cliente.identificacion}</div>
                  <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                  {/* FIX: null safety — guard detalle array and toFixed */}
                  {(showTicket.detalle || []).map((d, i) => (
                    <div key={i} className="d-flex justify-content-between">
                      <span>{d.nombre || ''} x{d.cantidad || 0}</span>
                      <span>${(parseFloat(d.total) || 0).toFixed(2)}</span>
                    </div>
                  ))}
                  <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                  {/* FIX: null safety — toFixed on possibly null monetary values */}
                  <div className="d-flex justify-content-between"><span>Subtotal 0%</span><span>${(parseFloat(showTicket.venta.subtotal_0) || 0).toFixed(2)}</span></div>
                  <div className="d-flex justify-content-between"><span>Subtotal IVA</span><span>${(parseFloat(showTicket.venta.subtotal_iva) || 0).toFixed(2)}</span></div>
                  <div className="d-flex justify-content-between"><span>IVA</span><span>${(parseFloat(showTicket.venta.iva) || 0).toFixed(2)}</span></div>
                  {parseFloat(showTicket.venta.descuento) > 0 && (
                    <div className="d-flex justify-content-between text-danger"><span>Descuento</span><span>-${(parseFloat(showTicket.venta.descuento) || 0).toFixed(2)}</span></div>
                  )}
                  <div className="d-flex justify-content-between fw-bold" style={{ fontSize: 16 }}>
                    <span>TOTAL</span><span>${(parseFloat(showTicket.venta.total) || 0).toFixed(2)}</span>
                  </div>
                  {showTicket.pagos && showTicket.pagos.length > 0 && (
                    <>
                      <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                      <div className="fw-bold small">Forma de Pago:</div>
                      {(showTicket.pagos || []).map((p, i) => (
                        <div key={i} className="small">
                          {metodoLabel(p.metodo)}: ${(parseFloat(p.monto) || 0).toFixed(2)}
                          {p.ultimos_digitos && ` (****${p.ultimos_digitos})`}
                          {p.autorizacion && ` Auth:${p.autorizacion}`}
                        </div>
                      ))}
                    </>
                  )}
                  {showTicket.factura && (
                    <>
                      <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                      <div className="fw-bold small">FACTURA ELECTRONICA</div>
                      <div style={{ fontSize: 9 }}>Clave: {showTicket.factura.clave_acceso || '-'}</div>
                    </>
                  )}
                  <hr className="my-1" style={{ borderStyle: 'dashed' }} />
                  <div className="text-center small">{showTicket.mensaje_pie}</div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowTicket(null)}>Cerrar</button>
                <button className="btn btn-primary" onClick={imprimirTicket}>
                  <i className="bi bi-printer me-1"></i>Imprimir Ticket
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ─── MODAL CERRAR CAJA ─── */}
      {showCerrarCaja && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title"><i className="bi bi-lock me-2"></i>Cerrar Caja</h5>
                <button className="btn-close btn-close-white" onClick={() => setShowCerrarCaja(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <p><strong>Caja:</strong> {cajaActiva.codigo}</p>
                  <p><strong>Apertura:</strong> {cajaActiva?.fecha_apertura ? new Date(cajaActiva.fecha_apertura).toLocaleString('es-EC') : '—'}</p>
                  <p><strong>Ventas del turno:</strong> {formatCurrency(cajaActiva.resumen_ventas?.total_monto || 0)}</p>
                </div>
                <label className="form-label fw-semibold">Monto contado en efectivo</label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text">$</span>
                  <input type="number" className="form-control" step="0.01"
                    value={montoCierre} onChange={e => setMontoCierre(e.target.value)} autoFocus />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowCerrarCaja(false)}>Cancelar</button>
                <button className="btn btn-danger" onClick={cerrarCaja}>
                  <i className="bi bi-lock me-1"></i>Cerrar Caja
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Historial */}
      {renderHistorial()}

      {/* ─── MODAL NUEVO CLIENTE RAPIDO ─── */}
      {showNuevoCliente && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-success text-white">
                <h5 className="modal-title"><i className="bi bi-person-plus me-2"></i>Nuevo Cliente Rapido</h5>
                <button className="btn-close btn-close-white" onClick={() => { setShowNuevoCliente(false); resetNuevoCliente(); }}></button>
              </div>
              <div className="modal-body">
                {/* Tipo persona */}
                <div className="d-flex gap-2 mb-3">
                  <button className={`btn flex-fill ${nuevoCliente.tipo_persona === 'natural' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setNuevoCliente({...nuevoCliente, tipo_persona: 'natural', tipo_identificacion: 'cedula', razon_social: ''})}>
                    <i className="bi bi-person me-1"></i>Natural
                  </button>
                  <button className={`btn flex-fill ${nuevoCliente.tipo_persona === 'juridica' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setNuevoCliente({...nuevoCliente, tipo_persona: 'juridica', tipo_identificacion: 'ruc', nombres: '', apellidos: ''})}>
                    <i className="bi bi-building me-1"></i>Juridica
                  </button>
                </div>

                {/* Identificacion */}
                <div className="row g-2 mb-3">
                  <div className="col-4">
                    <label className="form-label small fw-semibold">Tipo ID</label>
                    <select className="form-select form-select-sm" value={nuevoCliente.tipo_identificacion}
                      onChange={e => setNuevoCliente({...nuevoCliente, tipo_identificacion: e.target.value})}
                      disabled={nuevoCliente.tipo_persona === 'juridica'}>
                      <option value="cedula">Cedula</option>
                      <option value="ruc">RUC</option>
                      <option value="pasaporte">Pasaporte</option>
                    </select>
                  </div>
                  <div className="col-8">
                    <label className="form-label small fw-semibold">Identificacion *</label>
                    <div className="input-group input-group-sm">
                      <input type="text" className={`form-control ${ciValidacion.valido === true ? 'is-valid' : ciValidacion.valido === false ? 'is-invalid' : ''}`}
                        value={nuevoCliente.identificacion} placeholder={nuevoCliente.tipo_identificacion === 'cedula' ? '1234567890' : nuevoCliente.tipo_identificacion === 'ruc' ? '1234567890001' : 'Pasaporte'}
                        onChange={e => {
                          const val = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                          setNuevoCliente({...nuevoCliente, identificacion: val});
                        }}
                        onBlur={() => validarIdentificacion(nuevoCliente.identificacion, nuevoCliente.tipo_identificacion)}
                        maxLength={nuevoCliente.tipo_identificacion === 'ruc' ? 13 : nuevoCliente.tipo_identificacion === 'cedula' ? 10 : 20}
                        autoFocus
                      />
                      {ciValidacion.valido === true && <span className="input-group-text text-success"><i className="bi bi-check-circle"></i></span>}
                      {ciValidacion.valido === false && <span className="input-group-text text-danger"><i className="bi bi-x-circle"></i></span>}
                    </div>
                    {ciValidacion.existe && <small className="text-warning"><i className="bi bi-exclamation-triangle me-1"></i>Este cliente ya existe</small>}
                  </div>
                </div>

                {/* Datos segun tipo persona */}
                {nuevoCliente.tipo_persona === 'natural' ? (
                  <div className="row g-2 mb-3">
                    <div className="col-6">
                      <label className="form-label small fw-semibold">Nombres *</label>
                      <input type="text" className="form-control form-control-sm" value={nuevoCliente.nombres}
                        onChange={e => setNuevoCliente({...nuevoCliente, nombres: e.target.value.toUpperCase()})} placeholder="NOMBRES" />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-semibold">Apellidos *</label>
                      <input type="text" className="form-control form-control-sm" value={nuevoCliente.apellidos}
                        onChange={e => setNuevoCliente({...nuevoCliente, apellidos: e.target.value.toUpperCase()})} placeholder="APELLIDOS" />
                    </div>
                  </div>
                ) : (
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Razon Social *</label>
                    <input type="text" className="form-control form-control-sm" value={nuevoCliente.razon_social}
                      onChange={e => setNuevoCliente({...nuevoCliente, razon_social: e.target.value.toUpperCase()})} placeholder="RAZON SOCIAL" />
                  </div>
                )}

                {/* Contacto */}
                <div className="row g-2 mb-2">
                  <div className="col-6">
                    <label className="form-label small fw-semibold">
                      Email <span className="text-warning" title="Recomendado para envio de factura electronica (RIDE)"><i className="bi bi-exclamation-triangle-fill"></i></span>
                    </label>
                    <input type="email" className="form-control form-control-sm" value={nuevoCliente.email}
                      onChange={e => setNuevoCliente({...nuevoCliente, email: e.target.value})} placeholder="correo@ejemplo.com" />
                  </div>
                  <div className="col-6">
                    <label className="form-label small fw-semibold">Celular</label>
                    <input type="text" className="form-control form-control-sm" value={nuevoCliente.celular}
                      onChange={e => setNuevoCliente({...nuevoCliente, celular: e.target.value})} placeholder="0999999999" />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">Direccion</label>
                  <input type="text" className="form-control form-control-sm" value={nuevoCliente.direccion}
                    onChange={e => setNuevoCliente({...nuevoCliente, direccion: e.target.value})} placeholder="Direccion del cliente" />
                </div>

                <div className="alert alert-info py-2 small mb-0">
                  <i className="bi bi-info-circle me-1"></i>
                  <strong>Para facturacion SRI:</strong> El email es necesario para enviar el RIDE (comprobante electronico) al cliente.
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => { setShowNuevoCliente(false); resetNuevoCliente(); }}>Cancelar</button>
                <button className="btn btn-success" onClick={crearClienteRapido} disabled={creandoCliente}>
                  {creandoCliente ? (
                    <><span className="spinner-border spinner-border-sm me-2"></span>Creando...</>
                  ) : (
                    <><i className="bi bi-check-circle me-1"></i>Crear y Seleccionar</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Detalle Venta */}
      {showDetalle && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Venta <span className="fw-bold">{showDetalle.codigo}</span></h5>
                <button className="btn-close" onClick={() => setShowDetalle(null)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <small className="text-muted">Cliente</small>
                    <p className="fw-bold mb-1">{showDetalle.cliente_nombre || 'Consumidor Final'}</p>
                    <small className="text-muted">Vendedor</small>
                    {/* FIX: Null check for vendedor display */}
                    <p className="fw-bold mb-0">{showDetalle.vendedor || showDetalle.registrado_por_nombre || '-'}</p>
                  </div>
                  <div className="col-md-6 text-end">
                    <small className="text-muted">Fecha</small>
                    <p className="fw-bold mb-1">{showDetalle.created_at ? new Date(showDetalle.created_at).toLocaleString('es-EC') : '—'}</p>
                    <span className={`badge ${showDetalle.estado === 'completada' ? 'bg-success' : 'bg-danger'} me-1`}>{showDetalle.estado}</span>
                    <span className={`badge ${showDetalle.metodo_pago === 'efectivo' ? 'bg-success' : showDetalle.metodo_pago === 'tarjeta_medianet' ? 'bg-info' : showDetalle.metodo_pago === 'tarjeta_payphone' ? 'bg-danger' : showDetalle.metodo_pago === 'transferencia' ? 'bg-primary' : showDetalle.metodo_pago === 'mixto' ? 'bg-warning text-dark' : showDetalle.metodo_pago === 'credito' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                      <i className={`bi ${metodoIcon(showDetalle.metodo_pago)} me-1`}></i>
                      {metodoLabel(showDetalle.metodo_pago)}
                    </span>
                    {showDetalle.facturada && <span className="badge bg-primary ms-1">Facturada SRI</span>}
                  </div>
                </div>

                {/* [MIG-041] Seccion Entrega: visible siempre que la venta tenga estado_entrega tracking */}
                {showDetalle.estado_entrega && (
                  <div className={`alert ${showDetalle.estado_entrega === 'pendiente_stock' ? 'alert-warning' : showDetalle.estado_entrega === 'cancelada' ? 'alert-danger' : 'alert-success'} py-2 mb-3`} style={{ fontSize: '0.85rem' }}>
                    <div>
                      <strong>
                        <i className={`bi ${showDetalle.estado_entrega === 'pendiente_stock' ? 'bi-clock-history' : showDetalle.estado_entrega === 'cancelada' ? 'bi-x-circle' : 'bi-box2-heart'} me-1`}></i>
                        Entrega: {showDetalle.estado_entrega === 'pendiente_stock' ? 'PENDIENTE DE STOCK' : showDetalle.estado_entrega === 'cancelada' ? 'CANCELADA' : 'ENTREGADA'}
                      </strong>
                      {showDetalle.estado_entrega === 'pendiente_stock' && showDetalle.fecha_limite_entrega && (
                        <div className="mt-1">Fecha límite: <strong>{new Date(showDetalle.fecha_limite_entrega).toLocaleDateString('es-EC')}</strong></div>
                      )}
                      {showDetalle.estado_entrega === 'entregada' && showDetalle.fecha_entrega_real && (
                        <div className="mt-1">Entregada el <strong>{new Date(showDetalle.fecha_entrega_real).toLocaleString('es-EC')}</strong>
                          {showDetalle.compra_id_entrega && <span className="ms-1">(cubierta por compra #{showDetalle.compra_id_entrega})</span>}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <table className="table table-sm table-bordered">
                  <thead className="table-light">
                    <tr><th>Producto</th><th>Cant.</th><th>P.Unit</th><th>Desc.</th><th className="text-end">Total</th></tr>
                  </thead>
                  <tbody>
                    {showDetalle.detalle?.map(d => (
                      <tr key={d.id}>
                        <td>{d.producto_nombre} <small className="text-muted">({d.producto_codigo})</small></td>
                        <td>{d.cantidad}</td>
                        <td>{formatCurrency(d.precio_unitario)}</td>
                        <td>{parseFloat(d.descuento_porcentaje) > 0 ? `${d.descuento_porcentaje}%` : '-'}</td>
                        <td className="text-end fw-bold">{formatCurrency(d.total)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr><td colSpan={4} className="text-end">Subtotal</td><td className="text-end">{formatCurrency(showDetalle.subtotal)}</td></tr>
                    <tr><td colSpan={4} className="text-end">IVA ({showDetalle.iva_porcentaje || 15}%)</td><td className="text-end">{formatCurrency(showDetalle.iva_total)}</td></tr>
                    {parseFloat(showDetalle.descuento_total) > 0 && (
                      <tr className="text-danger"><td colSpan={4} className="text-end">Descuento</td><td className="text-end">-{formatCurrency(showDetalle.descuento_total)}</td></tr>
                    )}
                    <tr className="fw-bold"><td colSpan={4} className="text-end fs-5">TOTAL</td><td className="text-end fs-5 text-primary">{formatCurrency(showDetalle.total)}</td></tr>
                  </tfoot>
                </table>

                {/* Detalle de transacciones de pago */}
                {showDetalle.transacciones_pago && showDetalle.transacciones_pago.length > 0 && (
                  <div className="mt-3">
                    <h6 className="mb-2"><i className="bi bi-credit-card me-2"></i>Detalle de Pagos</h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered mb-0">
                        <thead className="table-light">
                          <tr><th>Metodo</th><th>Monto</th><th>Autorizacion</th><th>Tarjeta</th><th>Estado</th></tr>
                        </thead>
                        <tbody>
                          {(showDetalle.transacciones_pago || []).map(tp => (
                            <tr key={tp.id}>
                              <td>
                                <span className={`badge ${tp.metodo_pago === 'efectivo' ? 'bg-success' : tp.metodo_pago === 'tarjeta_medianet' ? 'bg-info' : tp.metodo_pago === 'tarjeta_payphone' ? 'bg-danger' : tp.metodo_pago === 'transferencia' ? 'bg-primary' : 'bg-secondary'}`}>
                                  {metodoLabel(tp.metodo_pago)}
                                </span>
                              </td>
                              <td className="fw-bold">{formatCurrency(tp.monto)}</td>
                              <td>{tp.codigo_autorizacion || '-'}</td>
                              <td>
                                {tp.ultimos_digitos ? `****${tp.ultimos_digitos}` : '-'}
                                {tp.marca_tarjeta && <small className="text-muted ms-1">({tp.marca_tarjeta})</small>}
                                {tp.tipo_tarjeta && <small className="text-muted ms-1">{tp.tipo_tarjeta}</small>}
                              </td>
                              <td>
                                <span className={`badge ${tp.estado === 'completada' ? 'bg-success' : 'bg-warning'}`}>{tp.estado}</span>
                                {tp.registrado_por_nombre && (
                                  <small className="text-muted d-block">
                                    <i className="bi bi-person me-1"></i>{tp.registrado_por_nombre}
                                  </small>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Sección Crédito + Abonos */}
                {showDetalle.es_credito && (
                  <div className="mt-3 border rounded p-3" style={{ backgroundColor: '#fff8e1' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0"><i className="bi bi-wallet2 me-2 text-warning"></i>Venta a Crédito</h6>
                      {parseFloat(showDetalle.saldo_pendiente) > 0 && showDetalle.estado !== 'anulada' && (
                        <button className="btn btn-warning btn-sm" onClick={() => { abrirAbonoModal(showDetalle); cargarAbonosVenta(showDetalle.id); }}>
                          <i className="bi bi-cash-coin me-1"></i>Registrar Abono
                        </button>
                      )}
                    </div>

                    {/* Barra de progreso */}
                    <div className="mb-2">
                      <div className="d-flex justify-content-between small mb-1">
                        <span>Abonado: <strong className="text-success">{formatCurrency(showDetalle.monto_abonado)}</strong></span>
                        <span>Saldo: <strong className="text-danger">{formatCurrency(showDetalle.saldo_pendiente)}</strong></span>
                      </div>
                      <div className="progress" style={{ height: '12px' }}>
                        <div
                          className="progress-bar bg-success"
                          style={{ width: `${Math.min(100, (parseFloat(showDetalle.monto_abonado) || 0) / (parseFloat(showDetalle.total) || 1) * 100)}%` }}
                        >
                          {Math.round(((parseFloat(showDetalle.monto_abonado) || 0) / (parseFloat(showDetalle.total) || 1)) * 100)}%
                        </div>
                      </div>
                    </div>

                    <div className="d-flex gap-3 small">
                      <span>Total: <strong>{formatCurrency(showDetalle.total)}</strong></span>
                      {showDetalle.fecha_vencimiento_credito && (
                        <span>
                          Vence: <strong>{showDetalle.fecha_vencimiento_credito ? new Date(showDetalle.fecha_vencimiento_credito).toLocaleDateString('es-EC') : '—'}</strong>
                          {showDetalle.fecha_vencimiento_credito && new Date(showDetalle.fecha_vencimiento_credito) < new Date() && parseFloat(showDetalle.saldo_pendiente) > 0 && (
                            <span className="badge bg-danger ms-1">Vencida</span>
                          )}
                        </span>
                      )}
                      {parseFloat(showDetalle.saldo_pendiente) <= 0 && (
                        <span className="badge bg-success">Pagada completamente</span>
                      )}
                    </div>

                    {/* Historial de abonos */}
                    {abonosHistorial.length > 0 && (
                      <div className="mt-3">
                        <h6 className="small fw-bold mb-2"><i className="bi bi-clock-history me-1"></i>Historial de Abonos</h6>
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.85em' }}>
                            <thead className="table-light">
                              <tr><th>Fecha</th><th>Monto</th><th>Método</th><th>Referencia</th><th>Usuario</th></tr>
                            </thead>
                            <tbody>
                              {(abonosHistorial || []).map(a => (
                                <tr key={a.id}>
                                  <td>{a.created_at ? new Date(a.created_at).toLocaleString('es-EC') : '—'}</td>
                                  <td className="fw-bold text-success">{formatCurrency(a.monto)}</td>
                                  <td>
                                    <span className={`badge ${a.metodo_pago === 'efectivo' ? 'bg-success' : a.metodo_pago === 'tarjeta_medianet' ? 'bg-info' : a.metodo_pago === 'transferencia' ? 'bg-primary' : 'bg-secondary'}`}>
                                      {metodoLabel(a.metodo_pago)}
                                    </span>
                                    {a.ultimos_digitos && <small className="ms-1">****{a.ultimos_digitos}</small>}
                                  </td>
                                  <td>{a.referencia || a.codigo_autorizacion || '-'}</td>
                                  <td>{a.usuario_nombre}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {abonosHistorial.length === 0 && !loadingAbonos && (
                      <button className="btn btn-link btn-sm p-0 mt-2" onClick={() => cargarAbonosVenta(showDetalle.id)}>
                        <i className="bi bi-arrow-repeat me-1"></i>Cargar historial de abonos
                      </button>
                    )}
                    {loadingAbonos && <div className="text-center mt-2"><div className="spinner-border spinner-border-sm"></div></div>}
                  </div>
                )}

                {/* Botones de accion */}
                <div className="d-flex gap-2 mt-3">
                  <button className="btn btn-outline-secondary btn-sm" onClick={() => cargarTicket(showDetalle.id)}>
                    <i className="bi bi-printer me-1"></i>Imprimir Ticket
                  </button>
                  {showDetalle.estado === 'completada' && !showDetalle.facturada && (
                    /* [CF sin SRI] Consumidor Final no se factura: solo comprobante interno */
                    (showDetalle.cliente_id && showDetalle.cliente_ci !== '9999999999999') ? (
                      <button className="btn btn-outline-primary btn-sm" onClick={() => generarFactura(showDetalle.id)}>
                        <i className="bi bi-file-earmark-check me-1"></i>Generar Factura SRI
                      </button>
                    ) : (
                      <span className="align-self-center small text-muted">
                        <i className="bi bi-info-circle me-1"></i>Consumidor Final: sin factura SRI — entregar comprobante interno
                      </span>
                    )
                  )}
                  {showDetalle.comprobante_id && (
                    <a href={`/api/v1/facturacion/${showDetalle.comprobante_id}/ride`} target="_blank" rel="noopener noreferrer"
                      className="btn btn-outline-danger btn-sm">
                      <i className="bi bi-file-pdf me-1"></i>RIDE PDF
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Registrar Abono */}
      {showAbonoModal && showDetalle && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1060 }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-warning text-dark">
                <h5 className="modal-title"><i className="bi bi-cash-coin me-2"></i>Registrar Abono</h5>
                <button className="btn-close" onClick={() => setShowAbonoModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info py-2 mb-3">
                  <div className="d-flex justify-content-between">
                    <span>Venta: <strong className="fs-6">{showDetalle.codigo}</strong></span>
                    <span>Saldo pendiente: <strong className="text-danger">{formatCurrency(showDetalle.saldo_pendiente)}</strong></span>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Monto del Abono *</label>
                  <div className="input-group">
                    <span className="input-group-text">$</span>
                    <input
                      type="number"
                      className="form-control form-control-lg"
                      value={abonoForm.monto}
                      onChange={e => setAbonoForm({ ...abonoForm, monto: e.target.value })}
                      max={parseFloat(showDetalle.saldo_pendiente)}
                      min="0.01"
                      step="0.01"
                      placeholder="0.00"
                      autoFocus
                    />
                    <button
                      className="btn btn-outline-success"
                      onClick={() => setAbonoForm({ ...abonoForm, monto: (parseFloat(showDetalle.saldo_pendiente) || 0).toFixed(2) })}
                    >
                      Pagar todo
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Método de Pago</label>
                  <div className="d-flex gap-2 flex-wrap">
                    {[
                      { value: 'efectivo', label: 'Efectivo', icon: 'bi-cash', color: 'success' },
                      { value: 'tarjeta_medianet', label: 'Tarjeta', icon: 'bi-credit-card', color: 'info' },
                      { value: 'transferencia', label: 'Transferencia', icon: 'bi-bank', color: 'primary' }
                    ].map(m => (
                      <button
                        key={m.value}
                        className={`btn ${abonoForm.metodo_pago === m.value ? `btn-${m.color}` : `btn-outline-${m.color}`} flex-fill`}
                        onClick={() => setAbonoForm({ ...abonoForm, metodo_pago: m.value })}
                      >
                        <i className={`bi ${m.icon} me-1`}></i>{m.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Campos Medianet */}
                {abonoForm.metodo_pago === 'tarjeta_medianet' && (
                  <div className="border rounded p-3 mb-3" style={{ backgroundColor: '#f0f8ff' }}>
                    <h6 className="small fw-bold mb-2"><i className="bi bi-credit-card me-1"></i>Datos de Tarjeta</h6>
                    <div className="row g-2">
                      <div className="col-6">
                        <label className="form-label small">Código Autorización</label>
                        <input type="text" className="form-control form-control-sm"
                          value={abonoForm.codigo_autorizacion}
                          onChange={e => setAbonoForm({ ...abonoForm, codigo_autorizacion: e.target.value })} />
                      </div>
                      <div className="col-6">
                        <label className="form-label small">Últimos 4 dígitos</label>
                        <input type="text" className="form-control form-control-sm" maxLength={4}
                          value={abonoForm.ultimos_digitos}
                          onChange={e => setAbonoForm({ ...abonoForm, ultimos_digitos: e.target.value.replace(/\D/g, '') })} />
                      </div>
                      <div className="col-6">
                        <label className="form-label small">Marca</label>
                        <select className="form-select form-select-sm"
                          value={abonoForm.marca_tarjeta}
                          onChange={e => setAbonoForm({ ...abonoForm, marca_tarjeta: e.target.value })}>
                          <option>Visa</option><option>Mastercard</option><option>Diners</option><option>Discover</option><option>Amex</option>
                        </select>
                      </div>
                      <div className="col-6">
                        <label className="form-label small">Tipo</label>
                        <select className="form-select form-select-sm"
                          value={abonoForm.tipo_tarjeta}
                          onChange={e => setAbonoForm({ ...abonoForm, tipo_tarjeta: e.target.value })}>
                          <option value="credito">Crédito</option><option value="debito">Débito</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {/* Transferencia: referencia */}
                {abonoForm.metodo_pago === 'transferencia' && (
                  <div className="mb-3">
                    <label className="form-label small">Nº Referencia / Comprobante</label>
                    <input type="text" className="form-control form-control-sm"
                      value={abonoForm.referencia}
                      onChange={e => setAbonoForm({ ...abonoForm, referencia: e.target.value })}
                      placeholder="Ej: TRF-123456" />
                  </div>
                )}

                {/* [MIG-039] Selector ítem específico */}
                {showDetalle.detalle && showDetalle.detalle.length > 0 && (
                  <div className="mb-3">
                    <label className="form-label small fw-bold">Ítems de esta venta</label>
                    <div className="border rounded p-2 mb-2 bg-light" style={{ maxHeight: '120px', overflowY: 'auto' }}>
                      {showDetalle.detalle.map(it => (
                        <div key={it.id} className="small d-flex justify-content-between border-bottom py-1">
                          <span>{it.producto_nombre} <span className="text-muted">× {it.cantidad}</span></span>
                          <span className="fw-bold">${parseFloat(it.total).toFixed(2)}</span>
                        </div>
                      ))}
                    </div>
                    <label className="form-label small">Aplicar abono a:</label>
                    <select className="form-select form-select-sm"
                      value={abonoForm.item_especifico_id}
                      onChange={e => {
                        const itemId = e.target.value;
                        const updates = { item_especifico_id: itemId };
                        // [UX 2026-05-07] Auto-sugerir motivo si está vacío o sub-15 chars
                        const motivoActual = (abonoForm.motivo || '').trim();
                        if (motivoActual.length < 15) {
                          if (itemId) {
                            const item = showDetalle.detalle.find(it => String(it.id) === String(itemId));
                            if (item) {
                              updates.motivo = `Abono sobre ${item.producto_nombre} ($${parseFloat(item.total).toFixed(2)})`;
                            }
                          } else if (showDetalle?.codigo) {
                            updates.motivo = `Abono general sobre venta ${showDetalle.codigo}`;
                          }
                        }
                        setAbonoForm({ ...abonoForm, ...updates });
                      }}>
                      <option value="">Abono general (toda la venta)</option>
                      {showDetalle.detalle.map(it => (
                        <option key={it.id} value={it.id}>
                          {it.producto_nombre} (${parseFloat(it.total).toFixed(2)})
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="mb-3">
                  <label className="form-label small">Notas (opcional)</label>
                  <input type="text" className="form-control form-control-sm"
                    value={abonoForm.notas}
                    onChange={e => setAbonoForm({ ...abonoForm, notas: e.target.value })}
                    placeholder="Observaciones del abono" />
                </div>

                {/* [MIG-039] Motivo OBLIGATORIO */}
                <div className="mb-2">
                  <label className="form-label small fw-bold">
                    Motivo / Justificativo <span className="text-danger">*</span>
                  </label>
                  <textarea className="form-control form-control-sm"
                    rows={2}
                    required
                    minLength={15}
                    maxLength={500}
                    placeholder="Se completará automáticamente al elegir un ítem arriba. Edítalo si quieres agregar detalle."
                    value={abonoForm.motivo}
                    onChange={e => setAbonoForm({ ...abonoForm, motivo: e.target.value })} />
                  <small className={(abonoForm.motivo?.trim().length || 0) < 15 ? 'text-danger' : 'text-success'}>
                    {(abonoForm.motivo?.trim().length || 0)}/15 caracteres mínimo
                  </small>
                  {(abonoForm.motivo?.trim().length || 0) < 15 && (
                    <div className="text-muted small mt-1">
                      <i className="bi bi-lightbulb me-1"></i>
                      Tip: selecciona el ítem arriba y el motivo se llenará solo.
                    </div>
                  )}
                </div>

                {/* [Elección SRI al saldar] Obligatoria cuando el abono deja el saldo en 0 */}
                {requiereEleccionSri() && (
                  <div className="border border-warning rounded p-3 bg-warning bg-opacity-10">
                    <div className="d-flex align-items-center mb-2">
                      <i className="bi bi-exclamation-triangle-fill text-warning me-2 fs-5"></i>
                      <div>
                        <strong className="d-block">Este abono salda la cuenta por completo</strong>
                        <small className="text-muted">Debe elegir cómo se documenta. La factura electrónica no se puede deshacer sin nota de crédito.</small>
                      </div>
                    </div>
                    <label className="form-label fw-semibold small mb-1">
                      <i className="bi bi-receipt me-1"></i>Facturación <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2">
                      <button type="button" className={`btn flex-fill ${abonoForm.facturar_sri === true ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setAbonoForm({ ...abonoForm, facturar_sri: true })}>
                        <i className="bi bi-file-earmark-check me-1"></i>Facturar CON SRI
                      </button>
                      <button type="button" className={`btn flex-fill ${abonoForm.facturar_sri === false ? 'btn-dark' : 'btn-outline-dark'}`}
                        onClick={() => setAbonoForm({ ...abonoForm, facturar_sri: false })}>
                        <i className="bi bi-printer me-1"></i>SIN SRI (comprobante interno)
                      </button>
                    </div>
                    {abonoForm.facturar_sri === null && (
                      <div className="small text-danger mt-1"><i className="bi bi-exclamation-circle me-1"></i>Debe elegir una opción para continuar.</div>
                    )}
                    {showDetalle?.facturar_sri === false && abonoForm.facturar_sri === null && (
                      <div className="small text-muted mt-1"><i className="bi bi-info-circle me-1"></i>Al crear esta venta se eligió SIN SRI.</div>
                    )}
                    {showDetalle?.facturar_sri === true && abonoForm.facturar_sri === null && (
                      <div className="small text-muted mt-1"><i className="bi bi-info-circle me-1"></i>Al crear esta venta se eligió CON SRI.</div>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAbonoModal(false)}>Cancelar</button>
                <button className="btn btn-warning" onClick={registrarAbono}
                  disabled={procesandoAbono || !abonoForm.monto || (abonoForm.motivo?.trim().length || 0) < 15 || (requiereEleccionSri() && abonoForm.facturar_sri === null)}>
                  {procesandoAbono ? <><span className="spinner-border spinner-border-sm me-1"></span>Procesando...</> : <><i className="bi bi-check-lg me-1"></i>Registrar Abono</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* [MIG-041] Modal: Sin stock - registrar como Entrega Pendiente? */}
      {showModalEntregaPendiente && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(21, 67, 96, 0.55)', backdropFilter: 'blur(2px)' }} onClick={(e) => e.target === e.currentTarget && setShowModalEntregaPendiente(null)}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0" style={{ borderRadius: 10 }}>
              <div className="modal-header" style={{ background: '#F39C12', color: 'white', borderRadius: '10px 10px 0 0' }}>
                <h6 className="modal-title fw-semibold mb-0">
                  <i className="bi bi-exclamation-triangle me-2"></i>Sin stock disponible
                </h6>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModalEntregaPendiente(null)}></button>
              </div>
              <div className="modal-body py-3">
                <p className="mb-2">
                  <strong>{showModalEntregaPendiente.producto?.nombre}</strong> no tiene stock en esta sucursal.
                </p>
                {parseFloat(showModalEntregaPendiente.producto?.precio_venta) > 0 ? (
                  <p className="mb-2 small text-muted">
                    Precio: <strong>{formatCurrency(showModalEntregaPendiente.producto?.precio_venta)}</strong>
                  </p>
                ) : (
                  <div className="alert alert-warning py-2 mb-2" style={{ fontSize: '0.85rem' }}>
                    <i className="bi bi-exclamation-triangle-fill me-1"></i>
                    Además, <strong>este producto no tiene precio asignado ($0.00)</strong>. Tendrás que escribir el precio en el carrito antes de cobrar.
                  </div>
                )}
                <p className="mb-2">
                  ¿Desea registrar la venta como <strong>Entrega Pendiente</strong>?
                </p>
                <div className="alert alert-info py-2 mb-0" style={{ fontSize: '0.85rem' }}>
                  <i className="bi bi-info-circle me-1"></i>
                  El cliente paga ahora y recibe la <strong>factura SRI inmediata</strong>. El stock NO se descuenta hasta que llegue la mercadería del proveedor. Cuando se confirme la compra del proveedor, el sistema marcará la entrega automáticamente.
                </div>
              </div>
              <div className="modal-footer py-2">
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setShowModalEntregaPendiente(null)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-sm btn-warning" onClick={() => activarEntregaPendienteYAgregar(showModalEntregaPendiente.producto)}>
                  <i className="bi bi-check2 me-1"></i>Sí, registrar como Entrega Pendiente
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ventas;
